<template>
  <div
    class="events_box pr"
    id="PlayoutEvents">
    <!-- 头部倒计时 -->
    <div class="play_event clearfix">
      <div class="next_live">
        <div class="video boxPadding">
          <div class="hide">
            {{ liveRid }} : {{ socketData }}
            <video-module
              :height="'108px'"
              :width="'192px'"
              :source="socketData"
              deviceType="T"
              :rid="liveRid"
              :useOldR="true"
              :sid="socketData.peerId"
              :status="socketData.status"
            />
          </div>
          <div
            class="video f_left videoWrap">
            <video-module
              :height="'108px'"
              :width="'192px'"
              :source="PlayListRCopy"
              deviceType="T"
              :rid="PlayListRCopy.livePeerId"
              :oldReceiverInfoObj="PlayListRCopy"
              :oldGetKernelStateObj="PlayListRCopy"
              :useOldR="false"
              :sid="PlayListRCopy.peerId"
              :status="PlayListRCopy.status"
            />
          </div>
          <el-tooltip class="item" effect="dark" :content="$t('lang.Restart')" placement="top">
              <i class="iconfont icon-refresh" @click="restartWebRtc" ></i>
          </el-tooltip>
        </div>
        <div class="boxPadding">
          <p class="ellipsis font-wei700">
           {{ $t('lang.PlayList')}}: {{ showEventObj[0] && showEventObj[0].title }}
          </p>
          <p class="ellipsis Scte" style="margin-top: 5px;" v-if="nextEventMessage.pgmStartScte&&nextEventMessage.pgmStartScte==1||nextEventMessage.pgmEndScte&&nextEventMessage.pgmEndScte==1" :title="$t('lang.nextPlayStart')"><i  class="iconfont icon-warning2"></i>{{nextEventMessage.pgmStartScte&&nextEventMessage.pgmStartScte==1? $t('lang.nextPlayStart'):$t('lang.nextPlayEnd')}}</p>
          <p class="ellipsis" style="margin-top: 5px;" v-else>{{ $t('lang.nextPlay')}}</p>
          <p class="ellipsis font-wei700 CountdownTime">{{ countDown.one }}</p>
          <p class="ellipsis" style="margin-top: 8px;">{{ $t('lang.nextSplice') }}</p>
          <p class="ellipsis font-wei700 CountdownTime">{{ NextSCTE.time }}</p>
        </div>
        <!-- 下一个scte -->
        <div class="boxPadding Next_SCTE">
          <p class="ellipsis NextLabel"  style="margin-top: 25px;">{{ $t('lang.currentSplice') }}</p>
          <p class="ellipsis font-wei700 CountdownTime">{{ CurrentSCTE.time }}</p>
          <p class="ellipsis NextLabel" style="margin-top: 8px;">{{ $t('lang.PassthroughSCTE') }}</p>
          <p class="ellipsis font-wei700 CountdownTime">{{ PassthroughSCTE.time }}</p>
        </div>
      </div>
    </div>
    <!-- 时间 -->
    <div class="date">
      <div class="dateTop">
        <div class="Today" @click="LinkCurrentTime">
        {{ $t('lang.currentTime') }}
      </div>
      <i
        class="el-icon-arrow-left pointer"
        @click="changeDate(true)"></i>
      <div class="timeSelete">
        <div class="calendar pointer pr">
          <p>{{ curDate | transformDate }}</p>
          <el-date-picker
            v-model="curDate"
            class="date_select"
            prefix-icon="none"
            clear-icon="none"
            type="date"
            @change="UpdateStartTimestamp"
          >
          </el-date-picker>
        </div>
        <div
          class="time_calc"
          v-if="false">
          <p>{{ $t('lang.schedOverUnder') }}</p>
          <p>{{ timeRemaining }}</p>
        </div>
      </div>
      <i
        class="el-icon-arrow-right pointer"
        @click="changeDate(false)"></i>
      </div>
      <div class="dateBottom" v-if="DstTime.isDst">
        <div class="Daylightstarts" v-if="DstSwitch.DstStart">{{ $t('lang.daylightStarts') }}</div>
        <div class="Daylightends" v-if="DstSwitch.DstEnd">{{ $t('lang.daylightEnds') }}</div>
      </div>
    </div>
    <!-- 事件的盒子 -->
    <div
      v-loading="loading"
      class="EventBoxWrap"
      id="listenRightClick"
      element-loading-background="rgba(0, 0, 0, .6)">
      <div class="calendar_day">
        <div class="calendarDayWrap"  v-if="!displayType">
          <div class="blank"></div>
          <!-- 事件存放盒子 -->
          <div class="EventWrap draggable_box">
            <div
              class="EventStyle"
              v-for="(itm) in eventList"
              :key="itm.id">
                <calendar-create-booking
                  :visibleVal="visible"
                  :data="itm"
                  :fixedDevice="fixedDevice"
                  :nextEventMessage='nextEventMessage'
                  :StartingUpLoading="StartingUpLoading"
                  :ScteData="ScteData"
                  @popupCreateBox="popupCreateBox"
                >
                </calendar-create-booking>
            </div>
          </div>
          <!-- 时间线 -->
          <div class="TimeLine" v-if="TimeLineMessage.switch" :style="{ top: TimeLineMessage.top + 'px'}">
          </div>
          <div
            class="time_box"
            v-for="(item, index) in timeArr"
            :key="item.name">
            <!-- 左边开始时间 -->
            <div class="time f_left">
              <p class="line f_right"></p>
              <p class="f_right">{{ TimeFormat ? item.name1 : item.name }}</p>
              <div class="time-scale">
                <p  style="opacity: 0;line-height: 50%;">:0-</p>
                <p>-</p>
                <p>:10<i class="el-icon-minus"></i></p>
                <p>-</p>
                <p>:20<i class="el-icon-minus"></i></p>
                <p>-</p>
                <p>:30<i class="el-icon-minus"></i></p>
                <p>-</p>
                <p>:40<i class="el-icon-minus"></i></p>
                <p>-</p>
                <p>:50<i class="el-icon-minus"></i></p>
                <p>-</p>
                <p style="opacity: 0;line-height: 50%;">:60-</p>
              </div>

            </div>
            <!-- :class="{'DstHour': ((DstSwitch.DstEnd && TimeQuantum <= 1) || (DstSwitch.DstDayBefore && TimeQuantum > 1)) && DstSwitch.DstHour == item.value}" 双列设置 -->
            <div class="event_box f_left pointer pr">
              <!-- @click.stop='openCreateBox($event, item.value)'> -->
              <!-- 每个小时剩余时间 -->
              <div class="time_calc">
                <!-- <p>{{ hourArr[index] }}</p> -->
                <div class="line"></div>
                <p :class="{'red': hourArr[item.value] < 60 * 60 * 1000 || hourArr[item.value] == undefined}">
                  {{
                    hourArr[item.value] | GETDURATION({ totalTime: 60 * 60 * 1000 })
                  }}
                </p>
              </div>
              <!-- 每个小时的每一分钟 -->
              <div
                class="min"
                v-for="idx in 60"
                :key="idx"
                :data-index="index"
                :data-hour="item.value"
                :data-min="idx - 1"
                @click="openCreateBox($event, item.value, index, idx - 1)"
              >
                <!-- <div
                  v-for="(itm, index) in eventList"
                  :key="index">
                  <div
                    v-if="
                      getHour(itm.breakTime ? itm.breakTime : itm.startTime) == item.value &&
                        getMin(itm.breakTime ? itm.breakTime : itm.startTime) == idx - 1
                    "
                    @click="
                      (e) => {
                        e.stopPropagation();
                      }
                    "
                  >
                    <calendar-create-booking
                      :visibleVal="visible"
                      :data="itm"
                      :fixedDevice="fixedDevice"
                      :dynamicDevice="dynamicDevice"
                      @closeCreateBox="closeCreateBox"
                      @popupCreateBox="popupCreateBox"
                    >
                    </calendar-create-booking>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- 事件列表模式 -->
        <div class="listDayWrap" v-else>
          <!-- <div class="blank"></div> -->
          <div class="listWrap">
            <!-- 没有事件时的间隔+ -->
            <div class="firstTimeGap"  v-if="!eventList.length">
              <i class="iconfont icon-fangda" @click="openNoEventBox($event)"></i>
            </div>
            <div class="listAll draggable_box" ref="listAll">
                <div
                class="listStyle"
                v-for="(itm, index) in eventList"
                :key="itm.id">
                <div class="preTimeGap"  v-if="index==0&&itm.startTime!=curDate.getTime()">
                  <i class="iconfont icon-fangda" @click="openPopupBox(itm,index,$event,1)"></i>
                  <!-- <time-gap-operation :eventData='itm'></time-gap-operation> -->
                </div>
                  <calendar-event-modes
                  :visibleVal="visible"
                  :data="itm"
                  :fixedDevice="fixedDevice"
                  :nextEventMessage='nextEventMessage'
                  @popupCreateBox="popupCreateBox">
                  </calendar-event-modes>
                  <div class="timeGap" :data-startGap='itm.endTime' :data-endGap='itm.endTime+itm.gapDuration'  v-if="itm.gapTime&&!itm.isLast">
                    <div><span>{{itm.gapTime}} {{ $t('lang.Gap') }} </span></div>
                    <div class="operation" v-if="itm.isShow">
                      <i  class="iconfont icon-fangda" @click="openPopupBox(itm,index,$event)"></i>
                      <time-gap-operation :eventData='itm' :type='0' :curDate='curDate' :TimeQuantum='TimeQuantum' @updateEvent='getAllEventList'></time-gap-operation>
                    </div>
                  </div>
              </div>
            </div>
            <div class="lastTimeGap"  v-if="eventList.length&&lastShow&&offsetHeight" :style="`height:calc(100% - ${offsetHeight}px)`"><i class="iconfont icon-fangda" @click=" openLastEventBox($event)"></i></div>
          </div>
          <!-- <div
            class="time_box"
            v-for="(item, index) in timeArr"
            :key="item.name">
            <div class="time f_left">
              <p class="line f_right"></p>
              <p class="f_right">{{ TimeFormat ? item.name1 : item.name }}</p>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <!-- 判断是否需要取整 -->
    <media-time-floor v-if="MediaTimeFloor.show" :MediaTimeFloor="MediaTimeFloor" @RoundSelectRes="RoundSelectRes"></media-time-floor>
    <!-- 创建框 -->
    <popup-box
      v-if="EventMotion.switch"
      :picthOnEvent="picthOnEvent"
      :EventMotion="EventMotion.motion"
      :fixedDevice="fixedDevice"
      :BoxPosition="createBox"
      :displayType='displayType'
      :displayTab="displayTab"
      @closeCreateBox="EventMotion.switch = false"
      @OperationSuccess="OperationSuccess"
    ></popup-box>
    <!-- 强制填充选项框 -->
    <force-fill-select v-if="forceFillMessage.show" :forceFillMessage='forceFillMessage' @forceFillSelect='forceFillSelect'></force-fill-select>
    <!-- 事件调整弹框 -->
    <event-time-adjustment v-if="eventAdjustmentData.show" :eventAdjustmentData="eventAdjustmentData"></event-time-adjustment>
     <!-- 右击事件操作 -->
    <right-click-operation v-if="OperationStyle.Switch" :OperationStyle="OperationStyle" :PitchEventList="PitchEventList" @DeleteMoreEvent="DeleteMoreEvent" @CopyandMoveEvent="CopyandMoveEvent"></right-click-operation>
    <time-select v-if="MoveandCopyTime.show" :MoveandCopyTime="MoveandCopyTime" :PitchEventList="PitchEventList" @ApplyStartFrom="ApplyStartFrom"></time-select>
  </div>
</template>

<script>
import Bus from '@/assets/js/vueBus.js'
import videoModule from '@/components/common/VideoC'
import { mapState, mapMutations } from 'vuex'
import calendarCreateBooking from './common/calendarCreateBooking'
import { listEvent } from '@/service/playout'
import Outil from '@/assets/js/utils.js'
import Drag from '@/assets/js/common/drag'
import toTips from '@/assets/js/toTipsObj'
import PopupBox from '@/components/common/PopupBox.vue'
import NotManyEdit from '@/assets/js/NotManyEdit.js'
import CalendarEventModes from './common/eventFormBox/calendarEventModes.vue'
import TimeGapOperation from '@/components/common/timeGapOperation.vue'
import { TimetableSideConfig } from '@/assets/js/common/ParamConfig.js'
import ForceFillSelect from '@/components/common/ForceFillSelect.vue'
import MediaTimeFloor from '@/components/file/MediaTimeFloor.vue'
import commonRequest from '@/assets/js/common/commonRequest.js'
import eventTimeAdjustment from '@/components/common/eventTimeAdjustment.vue'
import TimeSelect from '@/views/Playout/common/TimeSelect.vue'
import RightClickOperation from '@/views/Playout/common/RightClickOperation.vue'
export default {
  components: {
    calendarCreateBooking,
    videoModule,
    PopupBox,
    CalendarEventModes,
    TimeGapOperation,
    ForceFillSelect,
    MediaTimeFloor,
    eventTimeAdjustment,
    TimeSelect,
    RightClickOperation
  },
  props: {
    fixedDevice: Object,
    websockDate: Array
  },
  data () {
    return {
      // 30秒定时重试获取事件接口
      setTimeoutEvent: null,
      // 倒计时为零重试次数
      RetryCount: 0,
      // 夏令时相关开关
      DstSwitch: {
        DstStart: false,
        DstEnd: false,
        DstDayBefore: false,
        DstStartBefore: false,
        DstHour: 1
      },
      // 夏令时时间
      DstTime: {
        isDst: false
      },
      // 当前时间线信息
      TimeLineMessage: {
        switch: false,
        top: 0
      },
      // 下一个scte内容
      NextSCTE: {
        switch: true,
        countDown: 0,
        time: '00:00:00',
        startTime: 0,
        content: ''
      },
      // 当前SCTE信息
      CurrentSCTE: {
        switch: true,
        countDown: 0,
        time: '00:00:00',
        endTime: 0
      },
      // 流中scte信息
      PassthroughSCTE: {
        switch: false,
        countDown: 0,
        time: '00:00:00',
        endTime: 0,
        scteId: ''
      },
      // 是否是7.7版本
      isNewVersions: true,
      videoShowFrist: false,
      // takeNext开关
      takeNextSwitch: false,
      // 选中事件对象
      picthOnEvent: {},
      // 弹窗的动作,对于事件
      EventMotion: {
        switch: false,
        motion: 0
      },
      // 弹出框位置
      createBox: {},
      time: 24,
      // 选中时间那天的开始时间
      curDate: new Date(),
      // 时间表侧边显示
      timeArr: JSON.parse(JSON.stringify(TimetableSideConfig)),
      // 事件列表
      allEventList: [],
      eventList: [],
      visible: true,
      isShow: {
        createBox: false
      },
      event: {
        startTime: '',
        endTime: '',
        eventSegments: []
      },
      socketData: {},
      // 选中source的peerId
      liveRid: '',
      searchRSourceId: [],
      videoShow: {
        frist: false,
        two: false
      },
      // 当前时间最近两个事件
      showEventObj: [],
      // 最近两个事件倒计时
      countDown: {
        one: '00:00:00',
        two: '00:00:00'
      },
      // 计算最近两个事件计时器
      timer: {
        event: null
      },
      ele: null,
      form: {},
      loading: false,
      // 每小时剩余时间
      hourArr: [],
      // source及R的信息
      sourceAndR: {},
      // 正在live的livePeerId
      rLivePeerId: '',
      logoValue: '',
      addLogo: {
        show: false
      },
      defaultUrl: require('@/assets/img/logo_thumbnail.png'),
      videoTime: null,
      video2Muted: true,
      video1Muted: true,
      newMediaInfo: {},
      // playList预览
      PlayListRCopy: {},
      PlayListR: {},
      // 预览Link
      PreviewLink: '',
      // logo显示信息
      LogoShowMessage: {
        logoSetOn: 0,
        logoFileUrl: '',
        logoHeight: 0,
        logoWidth: 0,
        logoXOffset: 0,
        logoYOffset: 0
      },
      // 通过是否live显示logo
      IsLiveShowLogo: false,
      // 选择当天的时间段
      TimeQuantum: 0,
      // 当天时间段的初始时间
      TimeQuantumStart: 0,
      // 时间格式
      TimeFormat: 0,
      // event展示的模式
      displayType: 0,
      offsetHeight: 0,
      lastShow: false,
      nextEventMessage: {},
      programId: '',
      multipleModelType: 0,
      // 强制填充选择框数据
      forceFillMessage: {
        show: false
        // fillType: 1
      },
      // 间隙数据
      GapTime: {},
      // scte激活相关信息
      ScteData: {},
      // 是否取整
      MediaIsRound: false,
      // 增加提示是否取整
      MediaTimeFloor: {
        show: false,
        type: 'single', // 类型是多文件还是单文件
        ListStartTime: {} // 多文件创建的开始时间
      },
      // 事件调整信息
      eventAdjustmentData: {
        show: false
      },
      // 获取开机状态
      StartingUpLoading: false,
      // ctrl选中event的列表
      PitchEventList: [],
      // move，copy操作选择时间
      MoveandCopyTime: {
        type: 'Move',
        show: false,
        loading: false
      },
      // 右击操作样式
      OperationStyle: {
        Switch: false
      },
      displayTab: '',
      outputData: 0,
      // Shift加点击快捷节选中的事件
      ShiftClickData: {}
    }
  },
  filters: {
    // 计算hour
    calcHour (index) {
      const hour = index > 12 ? index % 12 : index
      hour == 0 ? 12 : hour
      if (index == 0) return '12 AM'
      return index > 12 ? `${hour} PM` : `${hour} AM`
    },
    // 转换日期
    transformDate (date) {
      date = typeof date == 'object' ? date : new Date(date)
      const monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      const weekArr = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      return `${
        monthArr[date.getMonth()]
      } ${date.getDate()}, ${date.getFullYear()} ${weekArr[date.getDay()]}`
    }
  },
  computed: {
    ...mapState({
      State: (state) => state,
      GetKernelStateObj: (state) => state.GetKernelStateObj,
      pageRequest: (state) => state.websocket.pageRequest,
      pageRWebsocket: (state) => state.websocket.pageRWebsocket,
      pageSerBusRequest: (state) => state.websocket.pageSerBusRequest,
      // 多选选中的文件夹
      PitchOnFileList: (state) => state.playout.PitchOnFileList,
      CloneDisabled: (state) => state.playout.CloneDisabled,
      // 用户权限
      UserChannelPermission: (state) => state.playout.UserChannelPermission,
      // ctrl+c 复制的事件
      CtrlCopyEvent: (state) => state.playout.CtrlCopyEvent,
      // 高级配置的某些参数
      AdvancedSetupConfig: (state) => state.playout.AdvancedSetupConfig
    }),
    // 一天的剩余时间
    timeRemaining () {
      const hourArr = this.hourArr.filter(Boolean)
      let useTime = 0
      hourArr.forEach((item) => {
        useTime += item
      })
      return this.$options.filters.GETDURATION(useTime, {
        totalTime: 24 * 60 * 60 * 1000
      })
    }
    // 判断这一天最后时间是否有事件
  },
  watch: {
    // 监听R信息变化
    PlayListR (item) {
      item.SDI = true
      if (this.PreviewLink) {
        item.WebRSDIFeedUrl = this.PreviewLink
      } else {
        item.WebRSDIFeedUrl = `${item.R.toUpperCase()}504C41594C495354`
      }
      this.PlayListRCopy = item
    },
    // 监听弹出框开关
    'EventMotion.switch' (item) {
      if (item) {
        // 禁止滚动条滚动
        $('.events_box .calendar_day').css('overflow-y', 'hidden')
      } else {
        // 开启滚动条滚动
        $('.events_box .calendar_day').css('overflow-y', 'scroll')
      }
    },
    // 行为同步
    'State.BehaviorChange' (data) {
      console.log('pla-center')
      if (typeof data != 'object') {
        return
      }
      if (data.action == 'EventListChange') {
        this.getAllEventList()
      } else if (data.action == 'ProgramInstanceStartup') {
        this.$notify({
          customClass: 'notifyGlobal',
          title: 'notifying',
          message: this.$t('lang.ErrHint'),
          duration: 0
        })
      } else if (data.action == 'playoutPreviewStatusModule') {
        // isRefreshPlayList==true 刷新页面事件
        if (data.isRefreshPlayList) {
          this.getAllEventList()
        }
        // status == 3 AD Break  status == 4 Breaking Source
        if (data.status == 3 || (data.status == 4 && data.scteEndTime)) {
          if (data.eventId) {
            this.CurrentSCTE.switch = true
            this.CurrentSCTE.endTime = data.status == 3 ? data.endTime : data.scteEndTime
          } else {
            this.CurrentSCTE.switch = false
            this.CurrentSCTE.time = '00:00:00'
          }
        }
      } else if (data.action == 'channelScteCountDown') {
        if (data.endTime) {
          if (data.scteId && data.scteId === this.PassthroughSCTE.scteId) {
            return
          }
          this.PassthroughSCTE.switch = true
          this.PassthroughSCTE.endTime = data.endTime
          this.PassthroughSCTE.scteId = data.scteId
        }
      } else if (data.action == 'repeatRecordingFileFailed') {
        this.$message({
          showClose: true,
          message: data.failedReason,
          type: 'warning'
        })
      } else if (data.action == 'autoUpdateOrDeleteFollowOnEvent') {
        this.eventAdjustmentData = { ...data.message, show: true }
      } else if (data.action == 'eventSourceModule') {
        const dataLog = {
          eventId: data.eventId,
          startTime: data.startTime,
          templateName: data.templateName
        }
        this.scheduleCofirm(dataLog)
      }
    }
  },
  created () {
    const TimeFormat = Outil.getDateTimeFormat()
    this.TimeFormat = TimeFormat.broadcastTimeFormat
    this.programId = this.$BehaviorSyns.getProgramId()
    // 获取夏令时以及一天时间段
    this.getDstandTimeQuantum()
    const today = new Date()
    // 获取当天时间段的开始时间
    if (today.getHours() >= this.TimeQuantum) {
      this.curDate = new Date(`${today.getFullYear()}/${today.getMonth() + 1}/${today.getDate()} ${this.TimeQuantum}:0:0`)
      this.TimeQuantumStart = new Date(`${today.getFullYear()}/${today.getMonth() + 1}/${today.getDate()} ${this.TimeQuantum}:0:0`)
    } else {
      const Millisecond = new Date(`${today.getFullYear()}/${today.getMonth() + 1}/${today.getDate()} 0:0:0`).getTime() - 60 * 60 * 1000
      const currentDay = new Date(Millisecond)
      this.curDate = new Date(`${currentDay.getFullYear()}/${currentDay.getMonth() + 1}/${currentDay.getDate()} ${this.TimeQuantum}:0:0`)

      this.TimeQuantumStart = new Date(`${currentDay.getFullYear()}/${currentDay.getMonth() + 1}/${currentDay.getDate()} ${this.TimeQuantum}:0:0`)
    }
    Bus.$on('updateEventList', this.getAllEventList)
    Bus.$on('leftListUpdate', this.registerDrag)
    Bus.$on('regDrag', this.registerDrag)

    Bus.$on('palySourceVideo', (v) => {
      this.sourceAndR = {}
      this.sourceAndR = v
      this.sourceAndR.selectR = this.fixedDevice
      this.outputData = 0
    })
    Bus.$on('outputstart', (data) => {
      console.log(data)
      this.outputData = data
    })

    Bus.$on('playSource', () => {
      this.playSource()
    })
    Bus.$on('stopSource', () => {
      this.stopSource()
    })
    Bus.$on('takeNextEvent', () => {
      this.takeNextEvent()
    })
    clearInterval(this.videoTime)

    Bus.$on('getWebrtc', (x) => {
      if (this.$refs.videoMp4) {
        this.$refs.videoMp4.srcObject = x
        this.$refs.videoMp4.muted = true
      }
    })
    Bus.$on('changeEventModes', (type) => {
      if (type == 'calendar') {
        this.displayType = 0
        this.$nextTick(() => {
          if (this.curDate.getTime() == this.TimeQuantumStart.getTime()) {
            this.LinkCurrentTime()
          }
        })
        this.getAllEventList()
      } else {
        this.displayType = 1
        this.isLastTimeEventHave()
        this.getAllEventList()
        // this.$nextTick(() => {
        //   const offsetHeight = this.$refs.listAll.offsetHeight
        //   this.offsetHeight = offsetHeight
        // })
        this.dealEventList()
      }
    })
    if (!this.pageSerBusRequest) {
      this.$createWebsocket.pageSerBusRequest()
    }
    this.getPreviewLink()
    this.getPreviewStatus()
  },
  mounted () {
    Bus.$on('playOutVideoR', (i) => {
      console.log('playOut--r')
      if (i.peerId != this.liveRid) {
        this.State.GetKernelStateObj = {}
        this.socketData = {}
        this.searchRSourceId = []
        // this.searchRSourceId.push(i.peerId,i.livePeerId)
        this.searchRSourceId[0] = i.peerId
        this.searchRSourceId[1] = i.livePeerId ? i.livePeerId : ''
        const arrStr = this.searchRSourceId.toString()
        this.sendTaskInfo(arrStr)
      }
      this.liveRid = i.peerId
      this.$store.state.selectRid = i.peerId
    })
    Bus.$on('programTemplateEdit', (i) => {
      this.EventMotion.switch = false
    })
    // 跳转指定事件
    Bus.$on('jumpDesignatedEvent', async (item) => {
      let dateTitle = ''
      if (item.hours < this.TimeQuantum) {
        dateTitle = item.beforeDay.split(' ')[0]
      } else {
        dateTitle = item.Day.split(' ')[0]
      }
      this.curDate = new Date(`${dateTitle} ${this.TimeQuantum}:0:0`)
      const timeInterval = new Date(item.Day).getTime() - this.curDate.getTime()
      $('.calendar_day').scrollTop(timeInterval / 10000)
      this.UpdateStartTimestamp()
    })
    // 默认滚动到当前时间
    const today = new Date()
    const date = this.TimeQuantumStart
    const timeInterval = today.getTime() - date.getTime()
    $('.calendar_day').scrollTop(timeInterval / 10000)
    this.getAllEventList()
    this.getPassthroughSCTE()
    this.getScteData()
    // 获取media是否取整
    commonRequest.getMediaIsRound().then((res) => {
      this.MediaIsRound = res
    })
    this.MonitorMouseButton()
  },

  methods: {
    ...mapMutations('playout', ['setCtrlCopyEvent']),
    // 监听键盘以及鼠标事件
    MonitorMouseButton () {
      this.$nextTick(() => {
        document.addEventListener('keydown', this.Onkeydown)
        document.getElementById('listenRightClick').addEventListener('contextmenu', this.OnRightClick)
        // 监听松开鼠标
        document.addEventListener('mouseup', this.OnLeftClick)
      })
    },
    // 监听键盘按下
    Onkeydown (e) {
      if (e.ctrlKey === true && e.keyCode == 67) {
        if (this.PitchEventList.length > 0) {
          this.setCtrlCopyEvent(this.PitchEventList)
          // 清除
          this.ClearMultiple()
        }
      }
    },
    // 计算位置
    CalculatePosition (e) {
      const windowWidth = window.innerWidth
      const windowHeight = window.innerHeight
      const distanceFromRight = windowWidth - e.clientX
      const distanceFromBottom = windowHeight - e.clientY
      const left = distanceFromRight < 120 ? e.clientX - 100 : e.clientX
      const top = distanceFromBottom < 100 ? e.clientY - 100 : e.clientY
      return {
        left: `${left}px`,
        top: `${top}px`
      }
    },
    // 监听鼠标右击
    OnRightClick (e) {
      // 鼠标右键点击
      // e.button == 2 || (e.button == 0 && this.MACCtrl)
      if (e.button == 2) {
        // 选中右击
        if (this.PitchEventList.length > 0) {
          e.preventDefault()
          const style = this.CalculatePosition(e)
          this.OperationStyle = {
            style,
            Switch: true,
            type: 0
          }
        } else if (this.CtrlCopyEvent && this.CtrlCopyEvent.length > 0) {
          // ctrl+c 右击
          // 获取当前右键点击的元素
          const targetElement = e.target
          // 找到具有data-id属性的祖先元素
          const parentElement = targetElement.closest('[data-id]')
          if (parentElement) {
            // 获取到data-id属性的值
            const dataId = parentElement.dataset.id
            // 根据需要进行后续处理
            e.preventDefault()
            const style = this.CalculatePosition(e)
            this.OperationStyle = {
              style,
              Switch: true,
              type: 1,
              event: true,
              dataId
            }
          } else {
            let startTime
            if (this.displayType == 1) {
              const ListMode = this.getListModeClickTime(e)
              startTime = ListMode
            } else {
              const EventMode = this.getEventModeClickTime(e)
              startTime = EventMode
            }
            e.preventDefault()
            const style = this.CalculatePosition(e)
            this.OperationStyle = {
              style,
              Switch: true,
              type: 1,
              event: false,
              startTime
            }
          }
        }
      }
    },
    // 监听左击
    OnLeftClick (e) {
      // 鼠标左键点击
      if (e.button == 0) {
        // 是否是对选中的事件进行操作
        if (e.target.dataset && e.target.dataset.id === 'MouseRightClick') return
        // Ctrl,shift还在按着
        if (e.ctrlKey || e.metaKey || e.shiftKey) return
        // 如果没有选中并且没有右击则不执行
        if (this.PitchEventList.length == 0 && !this.OperationStyle.Switch) return
        setTimeout(() => {
          // 正在移动copy删除
          if (this.MoveandCopyTime.show) return
          // 清除
          this.ClearMultiple()
        }, 100)
      }
    },
    // 判断是选中还是取消
    IsSelectedCancel (PitchItem) {
      const e = window.event || {}
      if (e.shiftKey) {
        if (this.ShiftClickData.id) {
          this.ShiftMultipleEvent(PitchItem)
        } else {
          this.CtrlClickMouse(PitchItem, e)
        }
        return true
      } else if (e.ctrlKey || e.metaKey) {
        // 点击时是否按住ctrl
        this.CtrlClickMouse(PitchItem, e)
        return true
      } else {
        this.ClearMultiple()
        return false
      }
    },
    // shift多选事件
    ShiftMultipleEvent (PitchEvent) {
      // 时间排序
      const PageAllEvent = this.eventList
      let firstEvent = false
      let secondEvent = false
      this.ClearMultiple('list')
      PageAllEvent.forEach((item) => {
        // 判断顺序不可变
        if (firstEvent && secondEvent) return
        if (this.ShiftClickData.id === item.id) {
          firstEvent = true
        }
        if (PitchEvent.id === item.id) {
          secondEvent = true
        }
        if (firstEvent || secondEvent) {
          const parentElement = document.querySelector(`.a${item.id}`)
          if (!parentElement) return
          this.PitchEventList.push(item)
          parentElement.style.border = 'solid 5px #83ED7C'
        }
      })
    },
    // ctrl加click选中 点击选中
    CtrlClickMouse (PitchItem, e) {
      if (!PitchItem.id || !e.target) return
      let PitchIndex = null
      this.PitchEventList.forEach((item, index) => {
        if (item.id == PitchItem.id) {
          PitchIndex = index
        }
      })
      const targetElement = e.target
      const parentElement = targetElement.closest(`.a${PitchItem.id}`)
      if (!parentElement) return
      this.ShiftClickData = PitchItem
      if (PitchIndex != null) {
        this.PitchEventList.splice(PitchIndex, 1)
        parentElement.style.border = 'solid 0px transparent'
      } else {
        this.PitchEventList.push(PitchItem)
        parentElement.style.border = 'solid 5px #83ED7C'
      }
    },
    // 清除鼠标点击，以及多选操作
    ClearMultiple (type) {
      this.PitchEventList.forEach((item) => {
        document.querySelector(`.a${item.id}`).style.border = 'solid 0px transparent'
      })
      this.PitchEventList = []
      this.$set(this.OperationStyle, 'Switch', false)
      if (type !== 'list') {
        this.ShiftClickData = {}
      }
    },
    // 获取时间表模式点击时间
    getEventModeClickTime (e) {
      let startDate
      const timestamp = typeof this.curDate == 'object' ? this.curDate.getTime() : this.curDate
      const offset = e.target.dataset.index
      // 选中的这个小时最后一个事件
      const preEvent = this.getPreEvent(
        e.target.dataset.hour,
        e.target.dataset.min,
        e.target.dataset.index
      )
      if (preEvent) {
        startDate = preEvent.endTime
      } else if (this.judgeDstAfter(e.target.dataset.hour) == 1) {
        startDate = new Date(timestamp + ((Number(offset) + 1) * 60 + Number(e.target.dataset.min)) * 60 * 1000).getTime()
      } else if (this.judgeDstAfter(e.target.dataset.hour) == 2) {
        startDate = new Date(timestamp + ((Number(offset) - 1) * 60 + Number(e.target.dataset.min)) * 60 * 1000).getTime()
      } else {
        startDate = new Date(timestamp + (Number(offset) * 60 + Number(e.target.dataset.min)) * 60 * 1000).getTime()
      }
      return startDate
    },
    // 获取列表模式点击时间
    getListModeClickTime (e) {
      let startTime
      const target = e.target
      if (target.className == 'preTimeGap' || target.className == 'firstTimeGap' || target.parentElement.className == 'preTimeGap' || target.parentElement.className == 'firstTimeGap') {
        if (new Date().getTime() > this.curDate.getTime()) {
          startTime = new Date().getTime() + 60 * 1000
        } else {
          startTime = this.curDate.getTime()
        }
      } else if (target.className == 'lastTimeGap' || target.parentElement.className == 'lastTimeGap') {
        const nowTimeDate = new Date().getTime()
        const preEndTime = this.eventList[this.eventList.length - 1].endTime
        if (nowTimeDate < preEndTime) {
          startTime = this.eventList[this.eventList.length - 1].endTime
        } else {
          startTime = new Date().getTime() + 60 * 1000
        }
      } else if (target.className == 'timeGap' || target.parentElement.className == 'timeGap') {
        let targetData
        if (target.className == 'timeGap') {
          targetData = e.target
        } else {
          targetData = e.target.parentElement
        }
        const startGap = targetData.dataset.startgap * 1
        const endGap = targetData.dataset.endgap * 1
        const nowTimes = new Date().getTime() + 60 * 1000
        if (startGap < nowTimes && nowTimes < endGap) {
          startTime = new Date().getTime() + 60 * 1000
        } else {
          startTime = targetData.dataset.startgap * 1
        }
      }
      return startTime
    },
    // 模板无媒体警告弹框
    scheduleCofirm (data) {
      this.$alert(this.$t('lang.templateNotProperly', { templateName: data.templateName }), {
        confirmButtonText: this.$t('lang.checkRecentEvent'),
        showCancelButton: false,
        dangerouslyUseHTMLString: true
      }).then(() => {
        const selectEvent = this.eventList.filter(v => v.eventId == data.eventId)
        if (selectEvent.length) {
          const timescroll = selectEvent[0].startTime - this.TimeQuantumStart.getTime()
          $('.calendar_day').scrollTop(timescroll / 10000)
          const position = { clientY: 345, clientX: window.innerWidth / 2 }
          this.openEventFormBox(position, selectEvent[0], 1)
        } else {
          this.changeDate(false, data.eventId)
        }
      }).catch(() => {

      })
    },
    // 重连webrtc
    restartWebRtc () {
      this.axios({
        method: 'post',
        url: Outil.getUrl('/extra/restartWebRtc'),
        data: {
          programId: this.programId,
          webPreviewId: this.PlayListRCopy.WebRSDIFeedUrl
        },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            this.$message({
              type: 'success',
              message: res.data.errorInfo
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.errorInfo
            })
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 获取scte激活相关信息
    getScteData () {
      this.axios({
        method: 'post',
        url: Outil.getUrl('/advance-setting/scte'),
        data: {
          programId: this.programId
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            const result = res.data.result
            this.ScteData = result
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 判断最后一个事件是否有时间空隙
    isLastTimeEventHave () {
      if (!this.eventList.length) return
      const lastTime = this.curDate.getTime() + 24 * 60 * 60 * 1000
      const lastEventStart = this.eventList[this.eventList.length - 1].startTime
      const lastEventEnd = this.eventList[this.eventList.length - 1].endTime
      if ((lastEventStart <= lastTime && lastTime <= lastEventEnd) || lastTime == lastEventEnd) {
        this.lastShow = false
      } else {
        this.lastShow = true
      }
    },
    // list模式点击弹框
    openPopupBox (item, index, $event, type) {
      this.event = {
        startTime: '',
        endTime: '',
        eventSegments: []
      }
      if (index + 1 == this.eventList.length && index != 0) {
        this.event.startTime = item.endTime
        this.event.endTime = item.endTime + 30 * 60 * 1000
      } else if (type == 1) {
        this.event.startTime = item.startTime - 30 * 60 * 1000
        this.event.endTime = item.startTime
      } else {
        this.event.startTime = item.endTime
        this.event.endTime = this.eventList[index + 1].startTime
      }
      this.openEventFormBox($event, this.event, 2)
    },
    // list模式一天没有事件时点击+
    openNoEventBox ($event) {
      this.event.startTime = this.curDate.getTime()
      this.event.endTime = this.curDate.getTime() + 30 * 60 * 1000
      this.openEventFormBox($event, this.event, 2)
    },
    // list模式last按钮点击
    openLastEventBox ($event) {
      let nowTime
      if (this.curDate.getTime() == this.TimeQuantumStart.getTime()) {
        nowTime = this.eventList[this.eventList.length - 1].endTime
        if (nowTime > new Date().getTime()) {
          this.event.startTime = nowTime
          this.event.endTime = nowTime + 30 * 60 * 1000
        } else {
          this.event.startTime = new Date().getTime()
          this.event.endTime = this.event.startTime + 30 * 60 * 1000
        }
      } else {
        nowTime = this.eventList[this.eventList.length - 1].endTime
        this.event.startTime = nowTime
        this.event.endTime = nowTime + 30 * 60 * 1000
      }
      this.openEventFormBox($event, this.event, 2)
    },
    // 获取选中那天的结束时间
    getEndTime () {
      const nextDateTime = Outil.changeNewDate(this.curDate.getTime() + 25 * 60 * 60 * 1000, 1)
      const deleteGapEndTime = new Date(`${nextDateTime} ${this.TimeQuantum}:00:00`).getTime()
      return deleteGapEndTime
    },
    // list模式处理数据
    dealEventList () {
      if (this.eventList.length) {
        this.isLastTimeEventHave()
      }
      this.$nextTick(() => {
        const offsetHeight = this.$refs.listAll && this.$refs.listAll.offsetHeight > 600 ? 600 : this.$refs.listAll && this.$refs.listAll.offsetHeight
        this.offsetHeight = offsetHeight
      })
      this.eventList = this.eventList.map((v, i) => {
        if (i + 1 == this.eventList.length) {
          return { ...v, gaptime: 0, isLast: true }
        } else if (this.eventList[i + 1].startTime - v.endTime) {
          if (this.eventList[i + 1].startTime <= new Date().getTime()) {
            return { ...v, gapTime: Outil.getDuration(this.eventList[i + 1].startTime - v.endTime), gapDuration: this.eventList[i + 1].startTime - v.endTime, isShow: false, gapEndTime: this.getEndTime() }
          } else {
            return { ...v, gapTime: Outil.getDuration(this.eventList[i + 1].startTime - v.endTime), gapDuration: this.eventList[i + 1].startTime - v.endTime, isShow: true, gapEndTime: this.getEndTime() }
          }
        } else {
          return { ...v, gaptime: 0 }
        }
      })
    },
    // 获取夏令时以及一天时间段
    getDstandTimeQuantum () {
      // 获取今年的夏令时时间
      const DstTime = Outil.DisplayDstSwitchDates(new Date().getYear())
      this.DstTime = DstTime
      const ProgramRMessage = Outil.getProgramReceiver()
      if (ProgramRMessage) {
        this.TimeQuantum = ProgramRMessage.broadcastDay
        const dayTime = this.timeArr.splice(0, this.TimeQuantum)
        this.timeArr.push(...dayTime)
      }
    },
    // 判断当前时间是否是夏令时结束后的时间
    judgeDstAfter (hour) {
      let DstType = 0
      if ((this.DstSwitch.DstEnd && this.TimeQuantum <= 1 && hour > 1) || (this.DstSwitch.DstDayBefore && this.TimeQuantum > 1 && hour > 1 && hour < this.TimeQuantum)) {
        DstType = 1
      } else if ((this.DstSwitch.DstStart && this.TimeQuantum <= 2) || (this.DstSwitch.DstStartBefore && this.TimeQuantum > 2 && hour > 2 && hour < this.TimeQuantum)) {
        DstType = 2
      }
      return DstType
    },
    // 连接跳转到当前时间
    LinkCurrentTime () {
      const today = new Date()
      const date = this.TimeQuantumStart
      const timeInterval = today.getTime() - date.getTime()
      console.log(today, date, timeInterval)
      if (this.curDate.getTime() == date.getTime()) {
        $('.calendar_day').scrollTop(timeInterval / 10000)
      } else {
        this.curDate = date
        $('.calendar_day').scrollTop(timeInterval / 10000)
        this.UpdateStartTimestamp()
      }
    },
    // 设置当前时间线
    setTimeLine () {
      const today = new Date()
      const date = this.TimeQuantumStart
      // 判断是否与今天在一天
      if (this.curDate.getTime() != date.getTime()) {
        this.TimeLineMessage.switch = false
      } else {
        const timeInterval = today.getTime() - date.getTime()
        if ((this.DstSwitch.DstEnd && this.TimeQuantum <= 1 && today.getTime() > this.DstTime.secondDstDate.startTime) || (this.DstSwitch.DstDayBefore && this.TimeQuantum > 1 && today.getTime() > this.DstTime.secondDstDate.startTime)) {
          this.TimeLineMessage.top = ((timeInterval - 60 * 60 * 1000) / 10000) + 31
        } else if ((this.DstSwitch.DstStart && this.TimeQuantum <= 2 && today.getTime() > this.DstTime.firstDstDate.startTime) || (this.DstSwitch.DstStartBefore && this.TimeQuantum > 2 && today.getTime() > this.DstTime.firstDstDate.startTime)) {
          this.TimeLineMessage.top = ((timeInterval + 60 * 60 * 1000) / 10000) + 31
        } else {
          this.TimeLineMessage.top = (timeInterval / 10000) + 31
        }
        this.TimeLineMessage.switch = true
      }
    },
    // 获取预览link信息
    getPreviewLink () {
      if (!this.programId) return
      this.axios({
        method: 'post',
        url: Outil.getUrl('/preview/link/info'),
        data: {
          programId: this.programId
        },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            this.PreviewLink = res.data.result.userid
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }
      })
        .catch((err) => {
          console.log(err)
        })
    },
    setInTimeVideo () {
      if (!this.videoShow.two) {
        let flag = false
        if (this.allEventList.length <= 0) return
        this.allEventList.forEach((v) => {
          if (v.color == 'rgb(15, 190, 113)') {
            this.videoShow.frist = true
            this.videoShowFrist = true
            this.videoShow.two = false
            flag = true
          }
        })
        if (!flag) {
          this.videoShow.frist = false
          this.videoShowFrist = false
        }
      }
    },
    getBase64Image (img, width, height) {
      // width、height调用时传入具体像素值，控制大小 ,不传则默认图像大小
      const canvas = document.createElement('canvas')
      canvas.width = width || img.width
      canvas.height = height || img.height

      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
      const dataURL = canvas.toDataURL()
      return dataURL
    },
    // 获取开机状态
    getStartStatus () {
      const ProgramId = Outil.getProgramReceiver().ProgramId
      if (!ProgramId) return
      this.axios({
        method: 'post',
        url: Outil.getUrl('/program/checkReceiverReady'),
        data: {
          programId: ProgramId
        },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            this.StartingUpLoading = false
          } else {
            this.StartingUpLoading = true
            this.StartWebsocket()
          }
        }
      })
        .catch((err) => {
          console.log(err)
        })
    },
    // websocket获取开机状态
    StartWebsocket () {
      const ProgramId = Outil.getProgramReceiver().ProgramId
      const urlInfo = JSON.parse(localStorage.getItem('channelInitConfig')).urlInfo
      const { websocketServerName } = urlInfo
      this.StopWebsocket()
      this.pageSerBusRequest.send({
        message: {
          serverName: websocketServerName,
          data: JSON.stringify({
            data: JSON.stringify({
              programId: ProgramId
            }),
            module: 'receiverAlreadyReady'
          })
        },
        time: 5000,
        key: 'receiverAlreadyReady',
        success: (res) => {
          if (res.result && res.result.data == 'SUCCESS') {
            if (this.StartingUpLoading) {

            }
            this.StartingUpLoading = false
            this.StopWebsocket()
          } else {
            this.StartingUpLoading = true
          }
        }
      })
    },
    // 停止预览
    StopWebsocket () {
      if (this.pageSerBusRequest) {
        this.$createWebsocket.pageSerBusRequest('stop', ['receiverAlreadyReady']) // 停止websocket
      }
    },
    // Take Next
    takeNextEvent () {
      if (
        (this.allEventList[0] && this.allEventList[0].liveStatus == 1) ||
        (this.allEventList[0] && this.allEventList[0].liveStatus == 5)
      ) {
        const data = {
          currentEventId: this.allEventList[0].eventId,
          booking: true,
          rid: this.fixedDevice.peerId
        }
        this.takeNextEventRequest(data)
      } else {
        const param = {
          rid: this.fixedDevice.peerId
        }
        this.takeNextEventRequest(param)
      }
    },
    // Take Next
    takeNextEventRequest (param) {
      if (this.takeNextSwitch) {
        return
      }
      this.takeNextSwitch = true
      Bus.$emit('nextLoading', true)
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/event/takeNextEvent', param, {
        contentType: 'application/json;charset=UTF-8'
      }).then((res) => {
        Bus.$emit('nextLoading', false)
        if (res.status == 200) {
          this.takeNextSwitch = false
          const { errorCode } = res.data
          if (errorCode === '0x0') {
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
            this.getAllEventList(1)
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        } else {
          return false
        }
      }).catch(() => {
        this.takeNextSwitch = false
        Bus.$emit('nextLoading', false)
      })
    },
    // Take Breaking Source
    playSource () {
      if (!this.sourceAndR.sourceData) {
        this.$message({
          type: 'warning',
          message: this.$t('lang.PleaseSelectSource')
        })
        return
      }
      if (this.sourceAndR.sourceData.peerId == this.rLivePeerId) {
        this.$message({
          type: 'warning',
          message: this.$t('lang.notSwitch')
        })
        return
      }

      if (this.sourceAndR.selectR) {
        const rObj = this.sourceAndR.selectR
        const sourceObj = this.sourceAndR.sourceData
        if (sourceObj.status == 2 && sourceObj.type == 'T') {
          this.$confirm(
            `${this.$t('lang.ReceiverDeviceOnLine1')}.${this.$t(
              'lang.ReceiverDeviceOnLine2'
            )}`,
            this.$t('lang.modelTips'),
            {
              confirmButtonText: this.$t('lang.Confirm'),
              cancelButtonText: this.$t('lang.cancel'),
              center: true,
              type: 'warning',
              callback: (action) => {
                if (`${action}` == 'confirm') {
                  this.sendStartVideo()
                }
              }
            }
          )
        } else if (rObj.status == 2) {
          this.$confirm(`${this.$t('lang.ReceiverOnLive1')}.${this.$t('lang.ReceiverOnLive2')}`, this.$t('lang.modelTips'), {
            confirmButtonText: this.$t('lang.Confirm'),
            cancelButtonText: this.$t('lang.cancel'),
            center: true,
            type: 'warning',
            callback: (action) => {
              if (`${action}` == 'confirm') {
                // 先结束在开始
                // this.stopSource("start");
                this.sendStartVideo()
              }
            }
          }
          )
        } else {
          this.sendStartVideo()
        }
      }
    },
    // Take PlayList
    stopSource (i) {
      const params = {
        rid: this.searchRSourceId[0]
      }
      Bus.$emit('playListLoading', true)
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/event/stopBreakSource', params, {
        timeout: 120000
      }).then(async (res) => {
        Bus.$emit('playListLoading', false)
        if (res.status == 200) {
          const { errorCode } = res.data
          if (errorCode === '0x0') {
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
          } else if (errorCode == '81100112') {
            Outil.ToTip(errorCode, 'warning', res.data.errorInfo)
            return false
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
            return false
          }
          this.EventMotion.switch = false
          this.getAllEventList()
        }
      }).catch(() => {})
    },
    // Take Breaking Source接口
    sendStartVideo () {
      const params = {
        rid: this.sourceAndR.selectR.peerId.toLowerCase(),
        sourceId: this.sourceAndR.sourceData.peerId.toLowerCase()
      }
      Bus.$emit('breakSourceLoading', true)
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/event/takeBreakSource', params, {
        timeout: 120000
      }).then(async (res) => {
        if (res.status == 200) {
          const { errorCode } = res.data

          if (errorCode === '0x0') {
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
            this.videoShow.first = false
            this.videoShow.two = true
          } else if (
            errorCode == '81100107' ||
            errorCode === '81100105' ||
            errorCode === '81100108'
          ) {
            Outil.ToTip(errorCode, 'warning', res.data.errorInfo)
            return false
          } else {
            Outil.ToTip(errorCode, 'warning', res.data.errorInfo)
            return false
          }
          Bus.$emit('breakSourceLoading', false)
          this.EventMotion.switch = false
          this.getAllEventList()
        }
      }).catch(() => {
        Bus.$emit('breakSourceLoading', false)
      })
    },
    sendTaskInfo (i) {
      if (this.pageRequest) {
        this.$createWebsocket.pageRequest('stop', 'taskInfo_TR')
      }
      const data = {
        type: 'taskInfo',
        module: 'taskInfo_TR',
        data: { peerIds: i }
      }

      this.pageRequest.send({
        message: data,
        time: 1000,
        key: 'taskInfo_TR',
        success: (res) => {
          this.$store.commit('playout/GET_FACILITY_MESSAGE', res.result)
          res.result.forEach((v) => {
            if (v.type == 'R') {
              if (this.sourceAndR.selectR) {
                this.sourceAndR.selectR.status = v.status
                this.sourceAndR.selectR.livePeerId = v.livePeerId
              }
              if (v.status == 2) {
                // 通过判断live状态显示logo
                this.IsLiveShowLogo = true

                this.rLivePeerId = v.livePeerId
                if (v.livePeerId != this.searchRSourceId[1]) {
                  this.searchRSourceId[1] = v.livePeerId
                }
                this.getQueryKennel(v.peerId)
                this.setInTimeVideo()
              } else {
                // 通过判断live状态显示logo
                this.IsLiveShowLogo = false
                if (this.isNewVersions) {
                  this.IsLiveShowLogo = true
                  this.getQueryKennel(v.peerId)
                  this.setInTimeVideo()
                }
                this.videoShow.frist = false
                this.videoShow.two = false
              }
            } else {
              this.socketData = v
            }
          })
          const taskInfo_TObj = this.pageRequest.sendMsgs.taskInfo_TR
          const arrStr = this.searchRSourceId.toString()
          if (taskInfo_TObj) {
            taskInfo_TObj.message = {
              type: 'taskInfo',
              module: 'taskInfo_TR',
              data: { peerIds: arrStr }
            }
          }
        }
      })
    },
    getQueryKennel (rid) {
      let sourceRid = ''
      // 判断是否的是Grid
      if (this.sourceAndR.type == 'gridSDI' || this.sourceAndR.type == 'gridPack') {
        if (this.sourceAndR.sourceData && this.sourceAndR.sourceData.peerId.length == 32) {
          const SDIpeerId = [this.sourceAndR.sourceData.peerId.substr(0, 16), this.sourceAndR.sourceData.peerId.substr(16, 16)]
          if (SDIpeerId[1] == '0000000000000001' || SDIpeerId[1] == '0000000000000002') {
            sourceRid = SDIpeerId[0]
          }
        }
      // 判断是否live
      } else if (this.sourceAndR.sourceData && this.sourceAndR.sourceData.status == 2) {
        sourceRid = this.sourceAndR.sourceData.livePeerId
      }
      const rids = sourceRid ? `${rid},${sourceRid}` : rid
      this.pageRWebsocket.send({
        message: { rid: rids, categoryId: '2152857600', operationType: '102' },
        time: 1000,
        isOnce: true,
        key: 'getQueryKennel',
        success: (res) => {
          const data = res.data ? JSON.parse(res.data) : {}
          if (res.rid == rid) {
            this.State.GetKernelStateObj = data
            this.PlayListR = JSON.parse(JSON.stringify(data))
            this.PlayListR.R = rid
          } else if (res.rid == sourceRid) {
            Bus.$emit('SourcePreview', {
              rid: res.rid,
              data
            })
          }
          if (this.sourceAndR.type == 'ext') {
            Bus.$emit('SourcePreview', {
              rid: res.rid,
              type: 'ext',
              data
            })
          }

          if (this.outputData) {
            Bus.$emit('outputPreview', {
              rid: res.rid,
              type: 'ext',
              data
            })
          }
        }
      })
    },
    // 重新绑定拖拽
    registerDrag () {
      this.$nextTick(() => {
        this.dragAndDrop()
      })
    },
    // 拖拽
    dragAndDrop () {
      this.ele = new Drag()
      this.ele.create({
        // 能够拖拽到的区域
        dropZones: document.querySelector('.events_box .calendar_day'),
        // 拖动的元素
        from: document.querySelectorAll('.draggable_box .draggable_item'),
        // // 拖拽结束的时候触发
        dropEnd: (e) => {
          if (this.UserChannelPermission == 5) {
            return
          }
          const id = this.ele.dragElement.dataset.id
          if (id) {
            this.EventDragMove(e, id)
            return
          }
          const device = JSON.parse(this.ele.dragElement.dataset.device)
          const programTemplate = this.ele.dragElement.dataset.programtemplate
          if (this.displayType == 1) {
            const startTime = this.getListModeClickTime(e)
            if (programTemplate) {
              this.DragProgramTemplate({ startTime: new Date(startTime), event: device })
            } else if (this.PitchOnFileList[device.id]) {
              const preEvent = null
              const offset = null
              this.batchAddEvent(preEvent, offset, e, startTime)
            } else {
              const preEvent = null
              const offset = null
              this.VideoAndFileEvent(device, preEvent, offset, e, startTime)
            }
          } else {
            let preEvent
            if (e.target.dataset.event) {
              const placeholderEvent = JSON.parse(e.target.dataset.event)
              preEvent = {
                endTime: placeholderEvent.startTime
              }
            } else {
            // 选中的这个小时最后一个事件
              preEvent = this.getPreEvent(
                e.target.dataset.hour,
                e.target.dataset.min,
                e.target.dataset.index
              )
            }
            const offset = e.target.dataset.index
            if (programTemplate) {
              let startDate
              const timestamp = typeof this.curDate == 'object' ? this.curDate.getTime() : this.curDate
              // 如果当前小时内点击处有上个事件
              if (preEvent) {
                startDate = preEvent.endTime
              } else if (this.judgeDstAfter(e.target.dataset.hour) == 1) {
                startDate = new Date(timestamp + ((Number(offset) + 1) * 60 + Number(e.target.dataset.min)) * 60 * 1000).getTime()
              } else if (this.judgeDstAfter(e.target.dataset.hour) == 2) {
                startDate = new Date(timestamp + ((Number(offset) - 1) * 60 + Number(e.target.dataset.min)) * 60 * 1000).getTime()
              } else {
                startDate = new Date(timestamp + (Number(offset) * 60 + Number(e.target.dataset.min)) * 60 * 1000).getTime()
              }
              this.DragProgramTemplate({
                startTime: new Date(startDate),
                event: device
              })
            } else if (this.PitchOnFileList[device.id]) {
              this.batchAddEvent(preEvent, offset, e)
            } else {
              this.VideoAndFileEvent(device, preEvent, offset, e)
            }
          }
          // 有夏令时并且选中的时间是夏令时重复
          // if (this.DstSwitch.DstEnd) {
          //   // true落在左半格
          //   if (IsLeftHalf) {
          //     startDate = this.DstTime.secondDstDate.lastHour
          //     stopDate = this.DstTime.secondDstDate.startTime
          //   } else {
          //     startDate = this.DstTime.secondDstDate.startTime
          //     stopDate = this.DstTime.secondDstDate.endTime
          //   }
          // }
        }
      })
    },
    // 取整选择结果
    RoundSelectRes (value) {
      if (this.MediaTimeFloor.type == 'single') {
        let videoTimes = this.form.videoTimes
        if (value == 1) {
          videoTimes = Math.floor(videoTimes)
        }
        this.form.duration = videoTimes * 1000
        this.form.endTime = this.form.startTime + videoTimes * 1000
        this.autoAddEvent()
      } else if (this.MediaTimeFloor.type == 'batch') {
        const ListStartTime = this.MediaTimeFloor.ListStartTime
        const IsRound = value == 1
        this.batchAddRequest(ListStartTime, IsRound)
      }
    },
    // 批量添加事件
    batchAddEvent (preEvent, offset, e, startTime) {
      let ListStartTime = 0
      const timestamp = typeof this.curDate == 'object' ? this.curDate.getTime() : this.curDate
      // 如果当前小时内点击处有上个事件
      if (preEvent) {
        ListStartTime = preEvent.endTime
      } else if (startTime) {
        ListStartTime = startTime
      } else if (this.judgeDstAfter(e.target.dataset.hour) == 1) {
        ListStartTime = new Date(timestamp + ((Number(offset) + 1) * 60 + Number(e.target.dataset.min)) * 60 * 1000).getTime()
      } else if (this.judgeDstAfter(e.target.dataset.hour) == 2) {
        ListStartTime = new Date(timestamp + ((Number(offset) - 1) * 60 + Number(e.target.dataset.min)) * 60 * 1000).getTime()
      } else {
        ListStartTime = new Date(timestamp + (offset * 60 + Number(e.target.dataset.min)) * 60 * 1000).getTime()
      }
      if (!this.MediaIsRound) {
        // 判断多个文件时间是否有浮点数
        const IsRound = Object.keys(this.PitchOnFileList).some((key) => {
          const item = this.PitchOnFileList[key]
          const videoTimes = item.videoTimes ? Number(item.videoTimes) : 0
          // 判断是否是浮点数
          return parseInt(videoTimes) !== videoTimes
        })
        if (IsRound) {
          this.MediaTimeFloor.show = true
          this.MediaTimeFloor.type = 'batch'
          this.MediaTimeFloor.ListStartTime = ListStartTime
          return
        }
      }
      this.batchAddRequest(ListStartTime, true)
    },
    // 事件拖拽
    EventDragMove (e, id) {
      if (this.CloneDisabled.Drag || this.CloneDisabled.disableButton) return
      let startTime = 0
      if (this.displayType == 1) {
        const ListMode = this.getListModeClickTime(e)
        startTime = ListMode
      } else {
        const EventMode = this.getEventModeClickTime(e)
        startTime = EventMode
      }
      if (!startTime) return
      const param = {
        cancelFirstEventFollowOn: false,
        programId: this.$BehaviorSyns.getProgramId(),
        eventIds: id,
        coverEvent: false,
        operationType: 0,
        startTime: startTime
      }
      this.loading = true
      this.axios({
        method: 'post',
        url: Outil.getUrl('/event/moveEvents'),
        data: param
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.$message({
            message: this.$t('lang.success'),
            type: 'success'
          })
          // 删除成功后刷新列表
          this.getCurDayEvent()
          this.loading = false
        } else {
          const errorInfo =
            this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
          this.loading = false
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 视频与文件创建事件
    async VideoAndFileEvent (device, preEvent, offset, e, startTime) {
      device.videoTimes = device.videoTimes ? Number(device.videoTimes) : device.videoTimes
      device.duration = device.videoTimes * 1000
      this.form.bitrate = 5120
      this.form.color = device.setType == 'break' ? 'rgb(146, 72, 199)' : 'rgb(255, 192, 0)',
      this.form.delay = 2
      this.form.description = ''
      this.form.reporter = ''
      this.form.rpeerid = this.fixedDevice.peerId
      this.form.scheduleType = 'live'
      this.form.title = device.name
      this.form.tname = device.name
      this.form.tpeerid = device.peerId || device.sourceId
      this.form.ttype = device.type
      this.form.turl = device.url
      let duration = 30 * 60 * 1000
      if (
        ['video', 'file'].includes(device.type.toLowerCase())
      ) {
        duration = device.duration
        this.form.sourceType = 0
        this.form.duration = device.duration
        this.form.record = 0
      } else {
        this.form.sourceType = 1
        this.form.record = this.AdvancedSetupConfig.defaultSecondaryRecord ? 1 : 0
        this.form.replay = this.form.record
      }
      console.log(this.form)
      const timestamp = typeof this.curDate == 'object' ? this.curDate.getTime() : this.curDate
      // 如果当前小时内点击处有上个事件
      if (preEvent) {
        this.form.startTime = preEvent.endTime
      } else if (startTime) {
        this.form.startTime = startTime
      } else if (this.judgeDstAfter(e.target.dataset.hour) == 1) {
        this.form.startTime = new Date(timestamp + ((Number(offset) + 1) * 60 + Number(e.target.dataset.min)) * 60 * 1000).getTime()
      } else if (this.judgeDstAfter(e.target.dataset.hour) == 2) {
        this.form.startTime = new Date(timestamp + ((Number(offset) - 1) * 60 + Number(e.target.dataset.min)) * 60 * 1000).getTime()
      } else {
        this.form.startTime = new Date(timestamp + (offset * 60 + Number(e.target.dataset.min)) * 60 * 1000).getTime()
      }
      this.form.endTime = this.form.startTime + duration
      let videoTimes = duration / 1000
      this.form.videoTimes = videoTimes
      // 判断是否是浮点数
      if (parseInt(videoTimes) !== videoTimes) {
        // 判断是否需要取整
        if (this.MediaIsRound) {
          videoTimes = Math.floor(videoTimes)
        } else {
          this.MediaTimeFloor.show = true
          this.MediaTimeFloor.type = 'single'
          return
        }
      }
      duration = videoTimes * 1000
      this.form.duration = duration
      this.form.endTime = this.form.startTime + duration
      this.autoAddEvent()
    },
    // 拖拽program模板
    DragProgramTemplate (data) {
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/event/addEventByTemplateId', {
        eventTemplateId: data.event.id,
        startTime: data.startTime.getTime(),
        receiverId: this.fixedDevice.peerId
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
            this.getAllEventList()
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }
      }).catch(() => {})
    },
    // 计算scte的开始时间
    computedScteStart (eventWrap, eventMessage) {
      let ScteStart = 0
      if (eventWrap && eventMessage) {
        const DownPosition = eventWrap.offsetY
        const EventHeight = eventWrap.target.offsetHeight
        const EventTime = eventMessage.endTime - eventMessage.startTime
        ScteStart = eventMessage.startTime + Math.round((DownPosition / EventHeight) * EventTime)
      }

      return ScteStart
    },
    // 批量添加事件请求接口
    batchAddRequest (ListStartTime, IsRound) {
      const EventList = []
      Object.keys(this.PitchOnFileList).forEach((key) => {
        const item = this.PitchOnFileList[key]
        let duration = item.videoTimes ? Number(item.videoTimes) : 0
        duration = IsRound ? Math.floor(duration) : duration
        const eventParam = {
          bitrate: 5120,
          color: item.setType == 'break' ? 'rgb(146, 72, 199)' : 'rgb(255, 192, 0)',
          delay: 2,
          rpeerid: this.fixedDevice.peerId,
          scheduleType: 'live',
          sourceType: 0,
          title: item.name,
          name: item.name,
          tpeerid: item.peerId || item.sourceId,
          ttype: item.type,
          turl: item.url,
          duration: duration * 1000
        }
        eventParam.startTime = ListStartTime
        eventParam.endTime = eventParam.startTime + eventParam.duration
        const eventSegments = {
          segmentId: 1,
          segmentOrder: 0,
          timingIn: eventParam.startTime,
          timingOut: eventParam.endTime
        }
        eventParam.eventSegments = [eventSegments]
        ListStartTime = eventParam.endTime
        EventList.push(eventParam)
      })
      this.axios({
        method: 'post',
        url: Outil.getUrl('/event/batchAdd'),
        data: {
          eventParams: EventList
        }
      }).then((res) => {
        if (res.status == 200 && res.data.errorCode == '0x0') {
          this.getAllEventList()
          return
        }
        const errorInfo =
          this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
        this.$message.error(errorInfo)
      }).catch(() => {})
    },
    // 强制填充弹框确认
    forceFillSelect (type) {
      if (type == 1) {
        this.form.startTime = this.GapTime.startTime
        this.form.endTime = this.GapTime.endTime
      } else {
        this.form.startTime = this.GapTime.startTime
        this.form.moveAllEventMoreThanEndTime = 1
      }
      this.addEvent()
    },
    // 拖拽后自动创建
    async autoAddEvent () {
      // 实时流填充间隙
      if (this.form.sourceType == 1) {
        const GapTime = await Outil.getEventGap(this.form.startTime)
        if (GapTime && GapTime.duration > 0) {
          if (GapTime.duration <= 1800000) {
            this.form.startTime = GapTime.startTime
            this.form.endTime = GapTime.endTime
          }
        }
      } else if (this.form.sourceType == 0) {
        const GapTime = await Outil.getEventGap(this.form.startTime)
        this.GapTime = GapTime
        if (GapTime.forcePopulate) {
          if (GapTime.duration != -2) {
            if (GapTime && GapTime.duration > 0) {
              if (GapTime.duration < this.form.duration) {
                this.forceFillMessage.show = true
                return
              }
            }
          }
        }
      }
      this.addEvent()
    },
    // 创建event
    addEvent () {
      if (this.form.title.length > 220) {
        this.$message.error(this.$t('lang.eventTitleLength'))
        return
      }
      this.loading = true
      const eventSegments = {
        segmentId: 1,
        segmentOrder: 0,
        timingIn: this.form.startTime,
        timingOut: this.form.endTime
      }
      this.form.eventSegments = [eventSegments]
      this.axios({
        method: 'post',
        url: Outil.getUrl('/event/add'),
        data: this.form,
        timeout: 120000
      }).then((res) => {
        if (res.status == 200 && res.data.errorCode == '0x0') {
          this.getAllEventList()
          return
        }
        this.loading = false
        const errorInfo =
          this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
        this.$message.error(errorInfo)
      }).catch(() => {
        this.loading = false
      })
    },
    // 获取小时
    getHour (time) {
      if (!time) return
      time = typeof time == 'object' ? time : new Date(time)
      return time.getHours()
    },
    // 获取分
    getMin (time) {
      if (!time) return
      time = typeof time == 'object' ? time : new Date(time)
      return time.getMinutes()
    },
    // 点击日历
    openCreateBox (e, hour, offset, min) {
      let currentDate
      const currentDay =
        typeof this.curDate == 'object'
          ? this.curDate.getTime()
          : this.curDate
      if (this.judgeDstAfter(hour) == 1) {
        currentDate = currentDay + ((offset + 1) * 60 + Number(min)) * 60 * 1000
      } else if (this.judgeDstAfter(hour) == 2) {
        currentDate = currentDay + ((offset - 1) * 60 + Number(min)) * 60 * 1000
      } else {
        currentDate = currentDay + (offset * 60 + Number(min)) * 60 * 1000
      }
      // 点击位置最近的上一个事件
      const preEvent = this.getPreEvent(hour, min, offset)
      if (preEvent) {
        currentDate = preEvent.endTime
      }
      if (currentDate <= new Date().getTime()) {
        this.$message.error(this.$t('lang.startTimeMoreCurTime'))
        return
      }
      this.event = {
        startTime: currentDate,
        endTime: currentDate + 30 * 60 * 1000,
        duration: 30 * 60 * 1000,
        tpeerid: '',
        record: false,
        //   新加子事件scte属性
        eventSegments: [],
        timeLock: 0,
        pgmEndScte: 0,
        pgmStartScte: 0
      }
      // 禁止里层滚动条滚动
      // $('.events_box .calendar_day').css('overflow-y', 'hidden')
      this.openEventFormBox(e, this.event, 2)
    },
    // 当前小时内的前一个最近事件
    getPreEvent (hour, min, offset) {
      // 当前这个小时内的所有事件
      const curHourEvent = []
      // 当前小时当前分钟内的所有事件
      const curMinEvent = []
      let preEvent
      this.eventList.forEach((v) => {
        // let startHour = this.getHour(v.startTime)
        // let startMin = this.getMin(v.startTime)
        if (v.liveStatus == 2 || v.liveStatus == 4) {
          return
        }
        const endHour = this.getHour(v.endTime)
        const endMin = this.getMin(v.endTime)
        // if (startHour == hour) {
        if (endHour == hour) {
          curHourEvent.push(v)
        }
        // if (startHour == hour && startMin == min) {
        if (endHour == hour && endMin == min) {
          curMinEvent.push(v)
        }
      })
      curMinEvent.sort((a, b) => a.startTime - b.startTime)
      // 如果点击分钟内有事件，开始时间紧跟这分钟内的结束时间
      if (curMinEvent.length) {
        preEvent = curMinEvent[curMinEvent.length - 1]
        return preEvent
      }
      // 如果点击分钟内没有事件，寻找这个小时内，最近的上个事件
      curHourEvent.sort((a, b) => a.startTime - b.startTime)
      // 如果点击小时内没有事件
      if (!curHourEvent.length) {
        return preEvent
      }
      const currentDay =
        typeof this.curDate == 'object' ? this.curDate.getTime() : this.curDate
      let clickTime
      if (this.judgeDstAfter(hour) == 1) {
        clickTime = currentDay + ((offset + 1) * 60 + Number(min)) * 60 * 1000
      } else if (this.judgeDstAfter(hour) == 2) {
        clickTime = currentDay + ((offset - 1) * 60 + Number(min)) * 60 * 1000
      } else {
        clickTime = currentDay + (offset * 60 + Number(min)) * 60 * 1000
      }
      curHourEvent.forEach((curEvent, i) => {
        if (!preEvent) {
          // 事件的结束时间小于点击时间
          if (curEvent.endTime <= clickTime) {
            preEvent = curEvent
          }
        } else {
          const curDiffer = clickTime - curEvent.endTime
          const preDiffer = clickTime - preEvent.endTime
          // 当前事件的时间小于点击时间，并且距离点击时间比上个事件的要近
          if (curDiffer >= 0 && preDiffer > curDiffer) {
            preEvent = curEvent
          }
        }
      })
      return preEvent
    },
    // 点击事件弹出创建框
    popupCreateBox (data) {
      // 获取是否ctrl加点击
      const CtrlDown = this.IsSelectedCancel(data.event)
      if (CtrlDown) return
      this.openEventFormBox(data.e, data.event, data.type)
    },
    // 打开创建编辑框
    openEventFormBox (e, event, type) {
      this.EventMotion.switch = false
      if (
        ['video', 'file', 'scte'].includes(
          event.ttype && event.ttype.toLowerCase()
        )
      ) {
        event.duration = event.endTime - event.startTime
      }
      if (type == 2) {
        this.picthOnEvent = { ...event, multipleModelType: 0 }
      } else {
        this.picthOnEvent = event
      }
      this.SetFramePosition(e)
      NotManyEdit.checkUserEdit({ type: 0, logicId: this.picthOnEvent.id }).then((res) => {
        if (res) {
          this.$nextTick(() => {
            this.EventMotion.motion = type == undefined ? 2 : type
            this.EventMotion.switch = true
          })
        }
      })
    },
    // event事件编辑创建删除完成
    OperationSuccess () {
      this.EventMotion.switch = false
      this.getAllEventList()
    },
    // 计算弹出框位置
    SetFramePosition (jsEvent) {
      const ClickEvent = jsEvent || window.event
      console.log(ClickEvent)
      const calendarRight = document.getElementById('PlayoutEvents')
      // 盒子距离上边左边距离
      const calendarLeft = calendarRight.offsetLeft
      const calendarRightTop =
        124 - document.getElementsByClassName('el-main')[0].scrollTop
      console.log(calendarRightTop)
      const FramePosition = {
        top: ClickEvent.clientY - calendarRightTop,
        left: ClickEvent.clientX - calendarLeft,
        bottom:
          calendarRight.clientHeight - ClickEvent.clientY + calendarRightTop,
        right: calendarRight.clientWidth - ClickEvent.clientX + calendarLeft,
        ArrowsLeft: 60
      }
      if (FramePosition.bottom >= 460 && FramePosition.right >= FramePosition.left) {
        this.createBox.top = FramePosition.top
        this.createBox.left = FramePosition.left - 70
        this.createBox.upward = true
        this.createBox.aleft = true
      } else if (FramePosition.bottom < 460 && FramePosition.right >= FramePosition.left) {
        this.createBox.top = FramePosition.top
        this.createBox.left = FramePosition.left - 70
        this.createBox.upward = false
        this.createBox.aleft = true
      } else if (FramePosition.bottom >= 460 && FramePosition.right < FramePosition.left) {
        this.createBox.top = FramePosition.top
        this.createBox.left = FramePosition.left + 70
        this.createBox.upward = true
        this.createBox.aleft = false
      } else {
        this.createBox.top = FramePosition.top
        this.createBox.left = FramePosition.left + 70
        this.createBox.upward = false
        this.createBox.aleft = false
      }
      const ScreenDistance = {
        left: ClickEvent.clientX,
        right: document.body.scrollWidth - ClickEvent.clientX
      }
      let Translation = 0
      if (this.createBox.aleft && ScreenDistance.right < 855) {
        Translation = ScreenDistance.right - 855
      } else if (!this.createBox.aleft && ScreenDistance.left < 855) {
        Translation = 855 - ScreenDistance.left
      }
      this.createBox.ArrowsLeft = FramePosition.ArrowsLeft + Math.abs(Translation)
      this.createBox.ArrowsLeft = this.createBox.ArrowsLeft > 360 ? 360 : this.createBox.ArrowsLeft
      this.createBox.top = this.createBox.top
      this.createBox.left = this.createBox.left + Translation
    },
    // 更改day
    changeDate (isPreDate, id) {
      let date =
        typeof this.curDate == 'object' ? this.curDate.getTime() : this.curDate
      if (this.DstTime.isDst) {
        const DstEnd = Outil.changeNewDate(this.DstTime.secondDstDate.tmpDate.getTime())
        // 当天为夏令时结束，并且点击切换到下一天
        if (((this.DstSwitch.DstEnd && this.TimeQuantum <= 1) || (this.DstSwitch.DstDayBefore && this.TimeQuantum > 1)) && !isPreDate) {
          date = date + 60 * 60 * 1000
        }
      }
      date = isPreDate
        ? date - 22 * 60 * 60 * 1000
        : date + 26 * 60 * 60 * 1000
      this.curDate = new Date(date)
      this.UpdateStartTimestamp(id)
    },
    // 获取事件列表及倒计时
    getAllEventList (type) {
      // 获取当前时间的事件
      this.getCurDayEvent()
      const params = {
        endDate: '15015547523410',
        rids: this.fixedDevice.peerId ? [this.fixedDevice.peerId] : [],
        startDate: -1,
        tid: '',
        notCareStart: true
      }
      listEvent(params).then((res) => {
        if (res.status == 200 && res.data.errorCode == '0x0') {
          this.allEventList = []
          const { result } = res.data
          result &&
            result.forEach((v) => {
              // 过去的事件不再执行
              if (v.liveStatus == 1 || v.liveStatus == 5) {
                v.color = 'rgb(15, 190, 113)'
              }
              if (v.liveStatus < 2 || v.liveStatus == 5) {
                if (v.pgmEndScte) {
                  if (v.endTime > new Date().getTime()) this.allEventList.push(v)
                } else {
                  this.allEventList.push(v)
                }
              }
            })
          // 按开始时间进行排序
          this.allEventList.sort((a, b) => a.startTime - b.startTime)
          this.showEventObj = [this.allEventList[0], this.allEventList[1]]
          this.getLatelyEvent()
          this.UpdateFirstColor(this.eventList)
          // take next后如果是暂停模式  查看开机状态
          if (type == 1) {
            this.getStartStatus()
          }
        } else {
          this.showEventObj = []
          this.retryGetEvent()
        }
      }).catch(() => {
        this.showEventObj = []
        this.retryGetEvent()
      })
    },
    // 当接口报错进行一个30秒之后的重试
    retryGetEvent () {
      if (!this.programId) return
      if (this.setTimeoutEvent) {
        clearTimeout(this.setTimeoutEvent)
        this.setTimeoutEvent = null
      }
      this.setTimeoutEvent = setTimeout(() => {
        this.getAllEventList()
      }, 30000)
    },
    // 时间变化时需要修改初始时间戳
    UpdateStartTimestamp (id) {
      this.curDate = new Date(`${this.curDate.getFullYear()}/${this.curDate.getMonth() + 1}/${this.curDate.getDate()} ${this.TimeQuantum}:0:0`)
      this.getCurDayEvent(id)
    },
    // 选中那一天的事件
    getCurDayEvent (id) {
      const currentDate = Outil.changeNewDate(this.curDate.getTime())
      if (this.DstTime.isDst) {
        const DstStart = Outil.changeNewDate(this.DstTime.firstDstDate.tmpDate.getTime())
        const DstEnd = Outil.changeNewDate(this.DstTime.secondDstDate.tmpDate.getTime())
        const DstDayBefore = Outil.changeNewDate(this.DstTime.secondDstDate.tmpDate.getTime() - 24 * 60 * 60 * 1000)
        const DstStartBefore = Outil.changeNewDate(this.DstTime.firstDstDate.tmpDate.getTime() - 24 * 60 * 60 * 1000)
        this.DstSwitch.DstStart = currentDate == DstStart
        this.DstSwitch.DstEnd = currentDate == DstEnd
        this.DstSwitch.DstDayBefore = currentDate == DstDayBefore
        this.DstSwitch.DstStartBefore = currentDate == DstStartBefore
      }
      this.loading = true
      this.ClearMultiple()
      this.getCurrentEvent().then(
        this.axios.spread((res1, res2, res3, res4) => {
          this.loading = false
          this.eventList = []
          const EventList = []
          let result = []
          const currentTime = new Date().getTime()
          const DayStartTime = this.curDate.getTime()
          result = result.concat(
            res1.data.result,
            res2.data.result,
            res3.data.result,
            res4.data.result
          )
          result &&
            result.forEach((v) => {
              v.colorBack = v.color || 'rgb(255, 192, 0)'
              // 过去的事件不再执行
              if ((v.liveStatus == 1) && (v.endTime > currentTime || v.eventModelType == 1)) {
                v.colorBack = 'rgb(15, 190, 113)'
              }
              if (v.liveStatus == 2 || (v.liveStatus == 4 && (v.failedReason == 'Take Next'))) v.colorBack = '#777777'
              if ((v.liveStatus == 4 && (v.failedReason != 'Take Next')) || v.liveStatus == 5 || v.liveStatus == 6) {
                v.colorBack = '#8A4B4B'
              }
              if (v.startTime < DayStartTime && v.endTime > DayStartTime) {
                v.breakTime = DayStartTime
              } else if (v.endTime <= DayStartTime) {
                return
              }
              if (v.eventSegments.length > 0) {
                let SerialNumber = 0
                v.eventSegments.forEach((item) => {
                  if (item.segmentId == 1) {
                    SerialNumber++
                    item.SerialNumber = SerialNumber
                  }
                })
              }
              v.ShowEndTime = v.endTime
              let IsAddHour = false
              if (this.DstTime.isDst) {
                // 冬令时相关判断
                // 跨过两个
                if ((v.startTime >= this.DstTime.secondDstDate.lastHour && v.startTime < this.DstTime.secondDstDate.startTime) && (v.endTime >= this.DstTime.secondDstDate.startTime && v.endTime < this.DstTime.secondDstDate.endTime)) {
                  v.ShowEndTime = this.DstTime.secondDstDate.startTime
                }
                // 第二个小时
                if (!this.displayType) {
                  if ((v.startTime >= this.DstTime.secondDstDate.startTime && v.startTime < this.DstTime.secondDstDate.endTime) && (v.endTime > this.DstTime.secondDstDate.startTime && v.endTime <= this.DstTime.secondDstDate.endTime)) {
                    return
                  }
                }
                const DSTHour = new Date(this.DstTime.firstDstDate.startTime).getHours()
                // 夏令时相关判断
                if ((this.DstSwitch.DstStart && this.TimeQuantum < DSTHour && v.startTime > this.DstTime.firstDstDate.startTime) || (this.DstSwitch.DstStartBefore && this.TimeQuantum >= DSTHour && v.startTime > this.DstTime.firstDstDate.startTime)) {
                  IsAddHour = true
                }
              }
              const curTime = this.curDate.getTime()
              const RendTime = this.getRenderingTime(v.startTime)
              const TimeInterval = RendTime - curTime
              if (TimeInterval > 0) {
                v.LocationTop = Math.floor(TimeInterval / 10000)
              } else {
                v.LocationTop = 0
              }
              if (IsAddHour) {
                v.LocationTop = v.LocationTop + Math.floor(60 * 60 * 1000 / 10000)
              }
              EventList.push(v)
            })
          // 按开始时间进行排序
          EventList.sort((a, b) => a.startTime - b.startTime)
          this.UpdateFirstColor(EventList)
          this.eventList.push(...EventList)
          if (this.displayType) {
            this.dealEventList()
          }

          this.getTotalUseTime()
          this.getNextSCTE()
          if (id) {
            const selectEvent = this.eventList.filter(v => v.eventId == id)
            if (!selectEvent[0]) return
            const timescroll = selectEvent[0].startTime - this.curDate.getTime()
            $('.calendar_day').scrollTop(timescroll / 10000)
            const position = { clientY: 345, clientX: window.innerWidth / 2 }
            this.openEventFormBox(position, selectEvent[0], 1)
          }
          this.registerDrag()
        })
      )
    },
    // 获取渲染时间
    getRenderingTime (startTime) {
      let RendTime = startTime
      const curTime = this.curDate.getTime()
      const curTimeEnd = curTime + 25 * 60 * 60 * 1000
      if (this.DstTime.isDst && curTime < this.DstTime.secondDstDate.startTime && this.DstTime.secondDstDate.startTime < curTimeEnd) {
        if (startTime > this.DstTime.secondDstDate.startTime) {
          RendTime = startTime - 3600000
        }
      }
      return RendTime
    },
    // 获取当前一天的事件
    getCurrentEvent () {
      const curDayStartTime =
        typeof this.curDate == 'object' ? this.curDate.getTime() : this.curDate
      const interval = 6 * 60 * 60 * 1000
      const time = [
        curDayStartTime,
        curDayStartTime + interval,
        curDayStartTime + interval * 2,
        curDayStartTime + interval * 3,
        curDayStartTime + interval * 4
      ]
      if (((this.DstSwitch.DstEnd && this.TimeQuantum <= 1) || (this.DstSwitch.DstDayBefore && this.TimeQuantum > 1))) {
        time[4] = time[4] + 60 * 60 * 1000
      } else if (((this.DstSwitch.DstStart && this.TimeQuantum <= 2) || (this.DstSwitch.DstStartBefore && this.TimeQuantum > 2))) {
        time[4] = time[4] - 60 * 60 * 1000
      }
      const that = this
      return this.axios.all([
        that.GetEventQuest(time[0], time[1] - 1, 3),
        that.GetEventQuest(time[1], time[2] - 1, 1),
        that.GetEventQuest(time[2], time[3] - 1, 1),
        that.GetEventQuest(time[3], time[4] - 1, 1)
      ])
    },
    // 请求
    GetEventQuest (startTime, endTime, type) {
      // type=0   notCareStart=false notCareEnd=false
      // type=1   notCareStart=false notCareEnd=true
      // type=2   notCareStart=true notCareEnd=false
      // type=3   notCareStart=true notCareEnd=true
      const param = {
        endDate: endTime,
        rids: this.fixedDevice.peerId ? [this.fixedDevice.peerId] : [],
        startDate: startTime,
        tid: '',
        showAudioLevel: true
      }
      if (type == 1) {
        param.notCareEnd = true
      } else if (type == 2) {
        param.notCareStart = true
      } else if (type == 3) {
        param.notCareStart = true
        param.notCareEnd = true
      }
      return this.axios({
        method: 'post',
        url: Outil.getUrl('/event/listEventByTR'),
        data: param,
        timeout: 120000,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          isCancelToken: true
        }
      })
    },
    // 计算每个小时的使用总时间
    getTotalUseTime () {
      this.hourArr = []
      this.eventList.forEach((v) => {
        v.eventSegments.forEach((item) => {
          if (item.segmentId != 13) {
            const startHour = this.getHour(item.timingIn)
            const endHour = this.getHour(item.timingOut)
            // 事件的开始时间和结束时间在同一小时内
            if (!(endHour - startHour)) {
              this.hourArr[startHour] =
            Number(this.hourArr[startHour] || 0) + (item.timingOut - item.timingIn)
              return
            }
            // 事件的开始时间和结束时间不在同一小时内
            const curDay =
          typeof this.curDate == 'object'
            ? this.curDate.getTime()
            : this.curDate
            const HoursDifference = endHour - startHour >= 0 ? endHour - startHour : endHour + 24 - startHour
            if (endHour - startHour < 0) {
              console.log(endHour - startHour, HoursDifference, 'qqqqqq')
            }
            for (let i = 0; i <= HoursDifference; i++) {
              let hour = i + startHour
              if (hour > 23) hour = hour - 24
              if (i == 0) {
                const end = new Date(item.timingIn)
                const endTime = new Date(`${Outil.changeNewDate(item.timingIn, 1)} ${end.getHours()}:00:00`).getTime() + 60 * 60 * 1000
                const timestamp = endTime - item.timingIn
                this.hourArr[hour] = Number(this.hourArr[hour] || 0) + timestamp
              } else {
                let timestamp
                if (i != HoursDifference) {
                  timestamp = 60 * 60 * 1000
                } else {
                  const start = new Date(item.timingOut)
                  const startTime = new Date(`${Outil.changeNewDate(item.timingOut, 1)} ${start.getHours()}:00:00`).getTime()
                  timestamp = item.timingOut - startTime
                }
                this.hourArr[hour] = Number(this.hourArr[hour] || 0) + timestamp
              }
            }
          }
        })
      })
    },
    // 显示最近两个事件
    getLatelyEvent () {
      if (this.timer.event) {
        clearInterval(this.timer.event)
        this.timer.event = null
      }
      this.timer.event = setInterval(() => {
        if (this.showEventObj[0] && !this.showEventObj[1]) {
          if (this.showEventObj[0].liveStatus == 1) {
            this.nextEventMessage = {}
          } else {
            this.nextEventMessage = this.showEventObj[0]
          }
        } else if (this.showEventObj[0] && this.showEventObj[1]) {
          if (this.showEventObj[0].liveStatus == 1) {
            this.nextEventMessage = this.showEventObj[1]
          } else {
            this.nextEventMessage = this.showEventObj[0]
          }
        } else {
          this.nextEventMessage = {}
        }
        this.countDown.one = this.showEventObj[0]
          ? Outil.getIntervalTime(new Date(), this.showEventObj[0].startTime)
          : '00:00:00'
        const start = this.showEventObj[0] ? this.showEventObj[0].startTime : 0
        const TimeInterval =
          new Date().getTime() -
          (typeof start == 'object' ? start.getTime() : start)
        if (this.showEventObj[0] && this.countDown.one == '00:00:00') {
          this.countDown.one = Outil.getIntervalTime(
            new Date(),
            this.showEventObj[0].endTime
          )

          if (this.countDown.one == '00:00:00' || (TimeInterval >= 0 && TimeInterval <= 1000)) {
            console.log('结束或者正在播放')
            this.RetryCount++
            if (this.RetryCount > 5) {
              if (this.RetryCount == 10 || this.RetryCount == 15 || this.RetryCount == 20) {
                this.getAllEventList()
              }
            } else {
              this.getAllEventList()
            }
          } else {
            this.RetryCount = 0
          }
        }
        // 判断是否有下一个scte
        if (this.NextSCTE.switch && this.NextSCTE.startTime) {
          this.NextSCTE.countDown = this.NextSCTE.startTime - new Date().getTime()
          this.NextSCTE.time = this.NextSCTE.countDown ? Outil.getIntervalTime(new Date(), this.NextSCTE.startTime) : '00:00:00'
          if (this.NextSCTE.countDown <= 0) {
            this.NextSCTE.switch = false
            this.NextSCTE.time = '00:00:00'
            this.getNextSCTE()
          }
        }
        // 判断是否有scte
        if (this.CurrentSCTE.switch && this.CurrentSCTE.endTime) {
          this.CurrentSCTE.countDown = this.CurrentSCTE.endTime - new Date().getTime()
          this.CurrentSCTE.time = this.CurrentSCTE.countDown ? Outil.getIntervalTime(new Date(), this.CurrentSCTE.endTime) : '00:00:00'
          if (this.CurrentSCTE.countDown <= 0) {
            this.CurrentSCTE.switch = false
            this.CurrentSCTE.time = '00:00:00'
          }
        }
        // 判断是否有PassthroughSCTE
        if (this.PassthroughSCTE.switch && this.PassthroughSCTE.endTime) {
          this.PassthroughSCTE.countDown = this.PassthroughSCTE.endTime - new Date().getTime()
          this.PassthroughSCTE.time = this.PassthroughSCTE.countDown ? Outil.getIntervalTime(new Date(), this.PassthroughSCTE.endTime) : '00:00:00'
          if (this.PassthroughSCTE.countDown <= 0) {
            this.PassthroughSCTE.switch = false
            this.PassthroughSCTE.time = '00:00:00'
          }
        }
        this.setTimeLine()
      }, 1000)
    },
    // 更新最近一个未播放事件的颜色
    UpdateFirstColor (EventList) {
      let FirstEventID = ''
      const currentTime = new Date().getTime()
      if (this.showEventObj.length > 0) {
        if (this.showEventObj[0] && this.showEventObj[0].startTime > currentTime) {
          FirstEventID = this.showEventObj[0].id
        } else if (this.showEventObj[1] && this.showEventObj[1].startTime > currentTime) {
          FirstEventID = this.showEventObj[1].id
        }
      }
      if (FirstEventID && EventList.length > 0) {
        // 第一个非空白事件修改颜色
        for (let i = 0; i < EventList.length; i++) {
          if (![1, 5].includes(EventList[i].liveStatus) && EventList[i].id == FirstEventID) {
            if (!(EventList[i].colorBack === 'rgb(255, 255, 255)' && !EventList[i].tpeerid)) {
              EventList[i].colorBack = 'rgb(255, 255, 0)'
            }
            break
          }
        }
      }
    },
    // 获取下一个scte
    getNextSCTE () {
      const startTime = new Date().getTime()
      if (!this.programId) return
      this.axios({
        method: 'post',
        url: Outil.getUrl('/scte/nextScte'),
        data: { startTime, programId: this.programId },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result.startTime) {
            this.NextSCTE.switch = true
            this.NextSCTE.startTime = Number(res.data.result.startTime)
            this.NextSCTE.content = res.data.result.content
          } else {
            this.NextSCTE.switch = false
            this.NextSCTE.time = '00:00:00'
          }
        } else if (res.data.errorCode == '80602014') {
          this.NextSCTE.switch = false
          this.NextSCTE.time = '00:00:00'
        } else {
          this.NextSCTE.switch = false
          this.NextSCTE.time = '00:00:00'
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {
        this.NextSCTE.switch = false
        this.NextSCTE.time = '00:00:00'
      })
    },
    // 获取当前播放的PassthroughSCTE
    getPassthroughSCTE () {
      if (!this.programId) return
      this.axios({
        method: 'post',
        url: Outil.getUrl('/event/getScteCountDownTime'),
        data: { programId: this.programId },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result
          if (result.endTime) {
            if (result.scteId && result.scteId === this.PassthroughSCTE.scteId) {
              return
            }
            this.PassthroughSCTE.switch = true
            this.PassthroughSCTE.endTime = Number(result.endTime)
            this.PassthroughSCTE.scteId = result.scteId
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {
      })
    },
    // 获取scte/预览状态
    getPreviewStatus () {
      const startTime = new Date().getTime()
      this.axios({
        method: 'post',
        url: Outil.getUrl('/program/runningEventStatus'),
        data: {
          startTime
        },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            const data = res.data.result
            if (data.status == 3 || (data.status == 4 && data.scteEndTime)) {
              this.CurrentSCTE.switch = true
              this.CurrentSCTE.endTime = data.status == 3 ? data.endTime : data.scteEndTime
            }
          } else if (res.data.errorCode == '80602014') {
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        }
      }).catch(() => {})
    },
    // 是否是选中的那一天
    isCurDayEvent (time) {
      const curDayStartTime =
        typeof this.curDate == 'object' ? this.curDate.getTime() : this.curDate
      const curDayEndTime = curDayStartTime + 24 * 60 * 60 * 1000 - 1
      if (time >= curDayStartTime && time <= curDayEndTime) {
        return true
      }
      return false
    },
    // delete，copy，move参数转换
    multiOperationParam (type) {
      const paramList = []
      let CopyEventList = []
      if (type == 'Copy') {
        CopyEventList = this.CtrlCopyEvent
      } else {
        CopyEventList = this.PitchEventList
      }
      CopyEventList.forEach((item) => {
        paramList.push(item.id)
      })
      if (type == 'delete') {
        return paramList
      } else {
        return paramList.join(',')
      }
    },
    // 删除多个事件
    DeleteMoreEvent () {
      this.$confirm(this.$t('lang.prompEnsureDel'), '', {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.cancel'),
        type: ''
      }).then(() => {
        const param = this.multiOperationParam('delete')
        this.axios({
          method: 'post',
          url: Outil.getUrl('/event/delete'),
          data: { ids: param },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message({
              message: this.$t('lang.success'),
              type: 'success'
            })
            // 删除成功后刷新列表
            this.getCurDayEvent()
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
          this.ClearMultiple()
        }).catch(() => {})
      }).catch(() => {
        // 取消操作
      })
    },
    // CopyandMove事件
    CopyandMoveEvent (value, type, other) {
      if (!value) {
        this.MoveandCopyTime.type = type
        this.MoveandCopyTime.show = true
      } else {
        let url
        if (type == 'Move') {
          url = '/event/moveEvents'
        } else {
          url = '/event/copyEvents'
        }
        const param = {
          programId: this.$BehaviorSyns.getProgramId(),
          eventIds: this.multiOperationParam(type),
          coverEvent: false,
          operationType: 0
        }
        if (type == 'Copy' && other.event) {
          param.operationType = other.event
          param.eventId = other.TimeAndId
        } else {
          param.startTime = other.TimeAndId
        }
        this.loading = true
        this.axios({
          method: 'post',
          url: Outil.getUrl(url),
          data: param,
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message({
              message: this.$t('lang.success'),
              type: 'success'
            })
            // 删除成功后刷新列表
            this.getCurDayEvent()
            this.loading = false
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
            this.loading = false
          }
          this.ClearMultiple()
        }).catch(() => {
          this.loading = false
        })
      }
    },
    // 选择copy，move时间
    ApplyStartFrom (time, ShowFollowOnHint) {
      this.MoveandCopyTime.show = false
      this.CopyandMoveEvent(true, this.MoveandCopyTime.type, {
        FollowOn: ShowFollowOnHint,
        TimeAndId: time
      })
    }
  },
  beforeDestroy () {
    this.boxElement && this.boxElement.close()
    this.$createWebsocket.pageRequest('stop', 'taskInfo_TR')
    Bus.$off('leftListUpdate', this.registerDrag)
    Bus.$off('updateEventList', this.getAllEventList)
    Bus.$off('takeNextEvent')
    Bus.$off('palySourceVideo')
    Bus.$off('outputstart')
    Bus.$off('playSource')
    Bus.$off('stopSource')
    Bus.$off('jumpDesignatedEvent')
    console.warn('websocket-centerBox')
    document.removeEventListener('keydown', this.Onkeydown)
    // document.getElementById('listenRightClick').removeEventListener('contextmenu', this.OnRightClick)
    // 监听松开鼠标
    document.removeEventListener('mouseup', this.OnLeftClick)
    if (this.timer.event) {
      clearInterval(this.timer.event)
      this.timer.event = null
    }
    if (this.setTimeoutEvent) {
      clearTimeout(this.setTimeoutEvent)
      this.setTimeoutEvent = null
    }
    clearInterval(this.videoTime)
  }
}
</script>
<style lang="less" scoped>
p {
  margin: 0;
}
#videoMp4 {
  border: none;
  outline: none;
  background: #333;
}
#videoMp5 {
  border: none;
  outline: none;
  background: #333;
}
.events_box {
  width: 100%;
  height: 100%;
  border-right: 2px solid #333;

  .play_event {
    width: 100%;
    padding: 0 3%;
    height: 137px;
    font-size: 12px;
    position: relative;

    p {
      margin-top: 6px;
      margin-bottom: 3px;
    }

    img {
      width: 0px;
    }
    .font-wei700 {
      font-weight: 700;
      line-height: 20px;
    }
    .next_live {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .boxPadding {
        padding: 2%;
        width: 34%;
        position: relative;
        .icon-refresh{
          position: absolute;
          top: 15px;
          right: 5px;
        }
        .ellipsis{
          font-size: 12px;
          color: rgba(223, 223, 223, 1);
          margin-top: 0px;
          margin-bottom: 0px;
          text-align: left;
        }
        .CountdownTime{
          font-size: 22px;
        }
        .Scte{
          color: #E56464;
        }
      }
      .Next_SCTE{
        width: 32%;
        padding: 2%;
        .ellipsis{
          color: #EC5050;
          margin-top: 0px;
        }
        .NextLabel{
          font-size: 12px;
        }
      }
      .videoWrap{
        position: absolute;
        width: 192px;
        height: 108px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);

      }
      .videoBox {
        width: 192px !important;
        height: 108px !important;
      }
    }

    .count_down_box {
      height: 50px;
      padding: 0 213px;
      // background: #252525;
      > div {
        width: 165px;

        p {
          margin: 0;
        }

        p:first-child {
          font-size: 12px;
          color: rgba(223, 223, 223, 1);
        }

        p:nth-child(2) {
          font-size: 26px;
          font-weight: bold;
          color: rgba(223, 223, 223, 1);
        }
      }

      > div.f_right p {
        color: #d23737;
      }
    }

    .count_down {
      height: 50px;
      background: #252525;
    }
  }

  .date {
    width: 100%;
    // height: 30px;
    background: #555;
    padding: 0 16px;
    margin-top: 10px;
    .dateTop{
      display: flex;
      align-items: center;
      padding: 5px 0px;
      .Today{
        width: 90px;
        height: 29px;
        background: #555555;
        border-radius: 4px;
        border: 1px solid #CCCCCC;
        font-size: 12px;
        color: #DFDFDF;
        line-height: 29px;
        cursor: pointer;
      }
      p {
        width: 100%;
        color: #dfdfdf;
        font-size: 14px;
        // margin: 0 30px;
      }

      i {
        font-size: 20px;
        color: #ccc;
        width: 20px;
      }

      .timeSelete {
        flex: 1;
      }

      .date_select {
        position: absolute;
        top: 0;
        opacity: 0;
        // left: 50%;
        // transform: translateX(-50%);
        input {
          border: none;
          background: transparent;
        }
      }

      .calendar {
        width: 47.6%;
        float: left;
        padding-left: 62px;
        text-align: left;
      }

      .time_calc {
        overflow: hidden;
        height: 100%;
        text-align: left;
        color: #dfdfdf;
        padding: 4px 0;

        p:first-child {
          height: 14px;
          line-height: 14px;
          font-size: 12px;
          width: 140px;
          text-align: center;
        }

        p:nth-child(2) {
          height: 24px;
          width: 140px;
          background-color: #252525;
          background: url("../../assets/img/over-under.png") no-repeat;
          background-size: contain;
          text-align: center;
          line-height: 24px;
          font-weight: bold;
          font-size: 16px;
          color: #dbdbdb;
        }
      }
    }
    .dateBottom{
      width: 100%;
      .Daylightstarts,.Daylightends{
        width: calc(100% - 90px);
        height: 20px;
        background: #068043;
        border-radius: 4px;
        margin-left:90px;
        text-align: left;
        padding-left: 29px;
      }
    }
  }

  .calendar_day {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    .calendarDayWrap{
      position: relative;
      overflow: hidden;
      .EventWrap{
        position: relative;
      }
      .TimeLine{
        position: absolute;
        top: 0px;
        right: 0;
        height: 1px;
        width: calc(100% - 95px);
        background: #EB4040;
        z-index: 999;
      }
      .TimeLine::after{
        content: '';
        width: 9px;
        height: 9px;
        background: #EB4040;
        border-radius: 50%;
        position: absolute;
        top: -4px;
        left: -8px;
      }
    }
    .listDayWrap{
      overflow: hidden;
       position: relative;
       height: 100%;
       overflow-y: scroll;
      .listWrap{
       position: relative;
       height: 100%;
       overflow-y: scroll;
       .firstTimeGap{
         color:  #E56464;
         text-align: right;
        padding-left: 100px;
        height: 32px;
        /* vertical-align: middle; */
        line-height: 32px;
        height: 100%;
        i{
          color: #999999;
          padding-right: 10px;
        }
       }
        .preTimeGap{
         color:  #E56464;
         text-align: right;
        padding-left: 100px;
        height: 32px;
        /* vertical-align: middle; */
        line-height: 32px;
        i{
          color: #999999;
          padding-right: 10px;
        }
        .el-dropdown{
           padding-right: 10px;
        }
       }
       .timeGap{
         color:  #E56464;
         text-align: left;
        padding-left: 100px;
        height: 32px;
        /* vertical-align: middle; */
        line-height: 32px;
        display: flex;
        justify-content: space-between;
        i{
          color: #999999;
          padding-right: 10px;
        }
        .el-dropdown{
          padding-right: 10px;
        }
       }
       .lastTimeGap{
         color:  #E56464;
         text-align: right;
        padding-left: 100px;
        height: 32px;
        /* vertical-align: middle; */
        line-height: 32px;
        height: 100%;
        i{
          color: #999999;
          padding-right: 10px;
        }
       }
      }
    }

    .blank {
      height: 31px;
      margin-left: 95px;
      border-left: 1px solid #333;
    }

    .time_box {
      min-height: 360px;
      width: 99.5%;
    }

    .time {
      width: 95px;
      min-height: 360px;
      font-size: 12px;
      color: #252525;
      text-align: right;
      position: relative;

      p:nth-child(2) {
        margin-right: 8px;
        margin-top: -6px;
      }

      .time-scale{
        height: 100%;
        width: 100%;
        display: flex;
        position: absolute;
        flex-direction: column;
        justify-content: space-between;
        p:nth-child(2) {
        margin-right: 0px;
        margin-top: 0px;
        }
      }

      .line {
        width: 9px;
        height: 10px;
        border-top: 1px solid #333;
      }
    }

    .time_box:first-child {
      p:nth-child(2) {
        margin-top: 0px;
      }
    }

    .event_box {
      border-top: 1px solid transparent;
      width: calc(100% - 95px);
      padding: 0 5px;
      text-align: left;
      color: #252525;
      height: 360px;
      border-left: 1px solid #333;
      box-sizing: border-box;

      .time_calc {
        position: absolute;
        top: -8px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 11;
        width: 100%;
        height: 0;

        .line {
          width: calc(100% + 9px);
          height: 1px;
          background: #333;
          position: absolute;
          left: -9px;
          top: 7px;
        }

        p {
          width: 88px;
          height: 14px;
          line-height: 14px;
          background-color: #252525;
          background: url("../../assets/img/over-under.png") no-repeat;
          background-size: contain;
          text-align: center;
          font-weight: bold;
          font-size: 11px;
          color: #999;
          position: relative;
          margin: auto;
          z-index: 1;
        }
        .red{
          color: #EC5050;
        }
      }
    }
    .DstHour{
      // overflow: hidden;
      .event_item{
        width: 50% !important;
      }
    }
    .min {
      height: 6px;
      position: relative;
    }

    .interval_time {
      height: 40px;
    }
  }
  .calendar_day::-webkit-scrollbar:horizontal {
    display: none;
  }
  .EventBoxWrap{
    height: calc(100% - 200px);
    position: relative;
    .StartingUpHintWrap{
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translate(-50%);
      z-index: 1000;
      .StartingUpHint{
        display: flex;
        justify-content: space-between;
        padding: 8px 10px;
        width: 400px;
        background: #252525;
        box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.5);
        border-radius: 4px;
        .Loading{
          width: 25px;
          height: 32px;
          ::v-deep .el-loading-mask{
            background-color: transparent;
            .el-loading-spinner{
              top: 86%;
             .circular {
                height: 16px;
                width: 16px;
              }
            }
          }
        }
        .StartHint{
          width: 336px;
          color: #DBDBDB;
          // word-break: break-all;
          text-align: left;
        }
        .lessenText{
          height: 32px;
          line-height: 32px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .questionMark{
          width: 30px;
          height: 30px;
          cursor: pointer;
          .lessen{
            width: 10px;
            height: 10px;
            margin: 6px auto;
            border: 3px solid #DBDBDB;
            border-color: transparent #DBDBDB #DBDBDB transparent;
            transform: rotate(45deg);
            border-radius: 2px;
          }
          i{
            font-size: 20px;
            color: #DBDBDB;
          }
        }
      }
    }
  }
}
</style>
